[
  {
    "key": "1_1_1_1_1_1_1_1_1_1_1_1",
    "scaleNumber": 1,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 1,
    "all_scales_index": 0
  },
  {
    "key": "1_1_1_1_1_1_1_1_1_1_2",
    "scaleNumber": 2,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 2,
    "all_scales_index": 1
  },
  {
    "key": "1_1_1_1_1_1_1_1_1_2_1",
    "scaleNumber": 3,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 2,
    "all_scales_index": 2
  },
  {
    "key": "1_1_1_1_1_1_1_1_2_1_1",
    "scaleNumber": 4,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 2,
    "all_scales_index": 4
  },
  {
    "key": "1_1_1_1_1_1_1_2_1_1_1",
    "scaleNumber": 5,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 2,
    "all_scales_index": 7
  },
  {
    "key": "1_1_1_1_1_1_2_1_1_1_1",
    "scaleNumber": 6,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 2,
    "all_scales_index": 13
  },
  {
    "key": "1_1_1_1_1_2_1_1_1_1_1",
    "scaleNumber": 7,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 2,
    "all_scales_index": 24
  },
  {
    "key": "1_1_1_1_2_1_1_1_1_1_1",
    "scaleNumber": 8,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 2,
    "all_scales_index": 44
  },
  {
    "key": "1_1_1_2_1_1_1_1_1_1_1",
    "scaleNumber": 9,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 2,
    "all_scales_index": 81
  },
  {
    "key": "1_1_2_1_1_1_1_1_1_1_1",
    "scaleNumber": 10,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 2,
    "all_scales_index": 149
  },
  {
    "key": "1_2_1_1_1_1_1_1_1_1_1",
    "scaleNumber": 11,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 10,
    "superscale_index": 2,
    "all_scales_index": 274
  },
  {
    "key": "2_1_1_1_1_1_1_1_1_1_1",
    "scaleNumber": 12,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 11,
    "superscale_index": 2,
    "all_scales_index": 504
  },
  {
    "key": "1_1_1_1_1_1_1_1_1_3",
    "scaleNumber": 13,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 3,
    "all_scales_index": 3
  },
  {
    "key": "1_1_1_1_1_1_1_1_3_1",
    "scaleNumber": 14,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 3,
    "all_scales_index": 6
  },
  {
    "key": "1_1_1_1_1_1_1_3_1_1",
    "scaleNumber": 15,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 3,
    "all_scales_index": 11
  },
  {
    "key": "1_1_1_1_1_1_3_1_1_1",
    "scaleNumber": 16,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 3,
    "all_scales_index": 20
  },
  {
    "key": "1_1_1_1_1_3_1_1_1_1",
    "scaleNumber": 17,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 3,
    "all_scales_index": 37
  },
  {
    "key": "1_1_1_1_3_1_1_1_1_1",
    "scaleNumber": 18,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 3,
    "all_scales_index": 68
  },
  {
    "key": "1_1_1_3_1_1_1_1_1_1",
    "scaleNumber": 19,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 3,
    "all_scales_index": 125
  },
  {
    "key": "1_1_3_1_1_1_1_1_1_1",
    "scaleNumber": 20,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 3,
    "all_scales_index": 230
  },
  {
    "key": "1_3_1_1_1_1_1_1_1_1",
    "scaleNumber": 21,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 3,
    "all_scales_index": 423
  },
  {
    "key": "3_1_1_1_1_1_1_1_1_1",
    "scaleNumber": 22,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 10,
    "superscale_index": 3,
    "all_scales_index": 778
  },
  {
    "key": "1_1_1_1_1_1_1_1_2_2",
    "scaleNumber": 23,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 4,
    "all_scales_index": 5
  },
  {
    "key": "1_1_1_1_1_1_1_2_2_1",
    "scaleNumber": 24,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 4,
    "all_scales_index": 9
  },
  {
    "key": "1_1_1_1_1_1_2_2_1_1",
    "scaleNumber": 25,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 4,
    "all_scales_index": 17
  },
  {
    "key": "1_1_1_1_1_2_2_1_1_1",
    "scaleNumber": 26,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 4,
    "all_scales_index": 31
  },
  {
    "key": "1_1_1_1_2_2_1_1_1_1",
    "scaleNumber": 27,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 4,
    "all_scales_index": 57
  },
  {
    "key": "1_1_1_2_2_1_1_1_1_1",
    "scaleNumber": 28,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 4,
    "all_scales_index": 105
  },
  {
    "key": "1_1_2_2_1_1_1_1_1_1",
    "scaleNumber": 29,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 4,
    "all_scales_index": 193
  },
  {
    "key": "1_2_2_1_1_1_1_1_1_1",
    "scaleNumber": 30,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 4,
    "all_scales_index": 355
  },
  {
    "key": "2_2_1_1_1_1_1_1_1_1",
    "scaleNumber": 31,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 4,
    "all_scales_index": 653
  },
  {
    "key": "2_1_1_1_1_1_1_1_1_2",
    "scaleNumber": 32,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 10,
    "superscale_index": 4,
    "all_scales_index": 505
  },
  {
    "key": "1_1_1_1_1_1_1_2_1_2",
    "scaleNumber": 33,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 5,
    "all_scales_index": 8
  },
  {
    "key": "1_1_1_1_1_1_2_1_2_1",
    "scaleNumber": 34,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 5,
    "all_scales_index": 15
  },
  {
    "key": "1_1_1_1_1_2_1_2_1_1",
    "scaleNumber": 35,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 5,
    "all_scales_index": 28
  },
  {
    "key": "1_1_1_1_2_1_2_1_1_1",
    "scaleNumber": 36,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 5,
    "all_scales_index": 51
  },
  {
    "key": "1_1_1_2_1_2_1_1_1_1",
    "scaleNumber": 37,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 5,
    "all_scales_index": 94
  },
  {
    "key": "1_1_2_1_2_1_1_1_1_1",
    "scaleNumber": 38,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 5,
    "all_scales_index": 173
  },
  {
    "key": "1_2_1_2_1_1_1_1_1_1",
    "scaleNumber": 39,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 5,
    "all_scales_index": 318
  },
  {
    "key": "2_1_2_1_1_1_1_1_1_1",
    "scaleNumber": 40,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 5,
    "all_scales_index": 585
  },
  {
    "key": "1_2_1_1_1_1_1_1_1_2",
    "scaleNumber": 41,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 5,
    "all_scales_index": 275
  },
  {
    "key": "2_1_1_1_1_1_1_1_2_1",
    "scaleNumber": 42,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 10,
    "superscale_index": 5,
    "all_scales_index": 506
  },
  {
    "key": "1_1_1_1_1_1_1_2_3",
    "scaleNumber": 43,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 6,
    "all_scales_index": 10
  },
  {
    "key": "1_1_1_1_1_1_2_3_1",
    "scaleNumber": 44,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 6,
    "all_scales_index": 19
  },
  {
    "key": "1_1_1_1_1_2_3_1_1",
    "scaleNumber": 45,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 6,
    "all_scales_index": 35
  },
  {
    "key": "1_1_1_1_2_3_1_1_1",
    "scaleNumber": 46,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 6,
    "all_scales_index": 64
  },
  {
    "key": "1_1_1_2_3_1_1_1_1",
    "scaleNumber": 47,
    "scale": [
      1,
      1,
      1,
      2,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 6,
    "all_scales_index": 118
  },
  {
    "key": "1_1_2_3_1_1_1_1_1",
    "scaleNumber": 48,
    "scale": [
      1,
      1,
      2,
      3,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 6,
    "all_scales_index": 217
  },
  {
    "key": "1_2_3_1_1_1_1_1_1",
    "scaleNumber": 49,
    "scale": [
      1,
      2,
      3,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 6,
    "all_scales_index": 399
  },
  {
    "key": "2_3_1_1_1_1_1_1_1",
    "scaleNumber": 50,
    "scale": [
      2,
      3,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 6,
    "all_scales_index": 734
  },
  {
    "key": "3_1_1_1_1_1_1_1_2",
    "scaleNumber": 51,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 6,
    "all_scales_index": 779
  },
  {
    "key": "1_1_1_1_1_1_1_3_2",
    "scaleNumber": 52,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 7,
    "all_scales_index": 12
  },
  {
    "key": "1_1_1_1_1_1_3_2_1",
    "scaleNumber": 53,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 7,
    "all_scales_index": 22
  },
  {
    "key": "1_1_1_1_1_3_2_1_1",
    "scaleNumber": 54,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 7,
    "all_scales_index": 41
  },
  {
    "key": "1_1_1_1_3_2_1_1_1",
    "scaleNumber": 55,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 7,
    "all_scales_index": 75
  },
  {
    "key": "1_1_1_3_2_1_1_1_1",
    "scaleNumber": 56,
    "scale": [
      1,
      1,
      1,
      3,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 7,
    "all_scales_index": 138
  },
  {
    "key": "1_1_3_2_1_1_1_1_1",
    "scaleNumber": 57,
    "scale": [
      1,
      1,
      3,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 7,
    "all_scales_index": 254
  },
  {
    "key": "1_3_2_1_1_1_1_1_1",
    "scaleNumber": 58,
    "scale": [
      1,
      3,
      2,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 7,
    "all_scales_index": 467
  },
  {
    "key": "3_2_1_1_1_1_1_1_1",
    "scaleNumber": 59,
    "scale": [
      3,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 7,
    "all_scales_index": 859
  },
  {
    "key": "2_1_1_1_1_1_1_1_3",
    "scaleNumber": 60,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 7,
    "all_scales_index": 507
  },
  {
    "key": "1_1_1_1_1_1_2_1_1_2",
    "scaleNumber": 61,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 8,
    "all_scales_index": 14
  },
  {
    "key": "1_1_1_1_1_2_1_1_2_1",
    "scaleNumber": 62,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 8,
    "all_scales_index": 26
  },
  {
    "key": "1_1_1_1_2_1_1_2_1_1",
    "scaleNumber": 63,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 8,
    "all_scales_index": 48
  },
  {
    "key": "1_1_1_2_1_1_2_1_1_1",
    "scaleNumber": 64,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 8,
    "all_scales_index": 88
  },
  {
    "key": "1_1_2_1_1_2_1_1_1_1",
    "scaleNumber": 65,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 8,
    "all_scales_index": 162
  },
  {
    "key": "1_2_1_1_2_1_1_1_1_1",
    "scaleNumber": 66,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 8,
    "all_scales_index": 298
  },
  {
    "key": "2_1_1_2_1_1_1_1_1_1",
    "scaleNumber": 67,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 8,
    "all_scales_index": 548
  },
  {
    "key": "1_1_2_1_1_1_1_1_1_2",
    "scaleNumber": 68,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 8,
    "all_scales_index": 150
  },
  {
    "key": "1_2_1_1_1_1_1_1_2_1",
    "scaleNumber": 69,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 8,
    "all_scales_index": 276
  },
  {
    "key": "2_1_1_1_1_1_1_2_1_1",
    "scaleNumber": 70,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 10,
    "superscale_index": 8,
    "all_scales_index": 508
  },
  {
    "key": "1_1_1_1_1_1_2_1_3",
    "scaleNumber": 71,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 9,
    "all_scales_index": 16
  },
  {
    "key": "1_1_1_1_1_2_1_3_1",
    "scaleNumber": 72,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 9,
    "all_scales_index": 30
  },
  {
    "key": "1_1_1_1_2_1_3_1_1",
    "scaleNumber": 73,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 9,
    "all_scales_index": 55
  },
  {
    "key": "1_1_1_2_1_3_1_1_1",
    "scaleNumber": 74,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 9,
    "all_scales_index": 101
  },
  {
    "key": "1_1_2_1_3_1_1_1_1",
    "scaleNumber": 75,
    "scale": [
      1,
      1,
      2,
      1,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 9,
    "all_scales_index": 186
  },
  {
    "key": "1_2_1_3_1_1_1_1_1",
    "scaleNumber": 76,
    "scale": [
      1,
      2,
      1,
      3,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 9,
    "all_scales_index": 342
  },
  {
    "key": "2_1_3_1_1_1_1_1_1",
    "scaleNumber": 77,
    "scale": [
      2,
      1,
      3,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 9,
    "all_scales_index": 629
  },
  {
    "key": "1_3_1_1_1_1_1_1_2",
    "scaleNumber": 78,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 9,
    "all_scales_index": 424
  },
  {
    "key": "3_1_1_1_1_1_1_2_1",
    "scaleNumber": 79,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 9,
    "all_scales_index": 780
  },
  {
    "key": "1_1_1_1_1_1_2_2_2",
    "scaleNumber": 80,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 10,
    "all_scales_index": 18
  },
  {
    "key": "1_1_1_1_1_2_2_2_1",
    "scaleNumber": 81,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 10,
    "all_scales_index": 33
  },
  {
    "key": "1_1_1_1_2_2_2_1_1",
    "scaleNumber": 82,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 10,
    "all_scales_index": 61
  },
  {
    "key": "1_1_1_2_2_2_1_1_1",
    "scaleNumber": 83,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 10,
    "all_scales_index": 112
  },
  {
    "key": "1_1_2_2_2_1_1_1_1",
    "scaleNumber": 84,
    "scale": [
      1,
      1,
      2,
      2,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 10,
    "all_scales_index": 206
  },
  {
    "key": "1_2_2_2_1_1_1_1_1",
    "scaleNumber": 85,
    "scale": [
      1,
      2,
      2,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 10,
    "all_scales_index": 379
  },
  {
    "key": "2_2_2_1_1_1_1_1_1",
    "scaleNumber": 86,
    "scale": [
      2,
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 10,
    "all_scales_index": 697
  },
  {
    "key": "2_2_1_1_1_1_1_1_2",
    "scaleNumber": 87,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 10,
    "all_scales_index": 654
  },
  {
    "key": "2_1_1_1_1_1_1_2_2",
    "scaleNumber": 88,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 10,
    "all_scales_index": 509
  },
  {
    "key": "1_1_1_1_1_1_3_1_2",
    "scaleNumber": 89,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 11,
    "all_scales_index": 21
  },
  {
    "key": "1_1_1_1_1_3_1_2_1",
    "scaleNumber": 90,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 11,
    "all_scales_index": 39
  },
  {
    "key": "1_1_1_1_3_1_2_1_1",
    "scaleNumber": 91,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 11,
    "all_scales_index": 72
  },
  {
    "key": "1_1_1_3_1_2_1_1_1",
    "scaleNumber": 92,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 11,
    "all_scales_index": 132
  },
  {
    "key": "1_1_3_1_2_1_1_1_1",
    "scaleNumber": 93,
    "scale": [
      1,
      1,
      3,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 11,
    "all_scales_index": 243
  },
  {
    "key": "1_3_1_2_1_1_1_1_1",
    "scaleNumber": 94,
    "scale": [
      1,
      3,
      1,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 11,
    "all_scales_index": 447
  },
  {
    "key": "3_1_2_1_1_1_1_1_1",
    "scaleNumber": 95,
    "scale": [
      3,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 11,
    "all_scales_index": 822
  },
  {
    "key": "1_2_1_1_1_1_1_1_3",
    "scaleNumber": 96,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 11,
    "all_scales_index": 277
  },
  {
    "key": "2_1_1_1_1_1_1_3_1",
    "scaleNumber": 97,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 11,
    "all_scales_index": 510
  },
  {
    "key": "1_1_1_1_1_1_3_3",
    "scaleNumber": 98,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      1,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 12,
    "all_scales_index": 23
  },
  {
    "key": "1_1_1_1_1_3_3_1",
    "scaleNumber": 99,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 12,
    "all_scales_index": 43
  },
  {
    "key": "1_1_1_1_3_3_1_1",
    "scaleNumber": 100,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 12,
    "all_scales_index": 79
  },
  {
    "key": "1_1_1_3_3_1_1_1",
    "scaleNumber": 101,
    "scale": [
      1,
      1,
      1,
      3,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 12,
    "all_scales_index": 145
  },
  {
    "key": "1_1_3_3_1_1_1_1",
    "scaleNumber": 102,
    "scale": [
      1,
      1,
      3,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 12,
    "all_scales_index": 267
  },
  {
    "key": "1_3_3_1_1_1_1_1",
    "scaleNumber": 103,
    "scale": [
      1,
      3,
      3,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 12,
    "all_scales_index": 491
  },
  {
    "key": "3_3_1_1_1_1_1_1",
    "scaleNumber": 104,
    "scale": [
      3,
      3,
      1,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 12,
    "all_scales_index": 903
  },
  {
    "key": "3_1_1_1_1_1_1_3",
    "scaleNumber": 105,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 12,
    "all_scales_index": 781
  },
  {
    "key": "1_1_1_1_1_2_1_1_1_2",
    "scaleNumber": 106,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 13,
    "all_scales_index": 25
  },
  {
    "key": "1_1_1_1_2_1_1_1_2_1",
    "scaleNumber": 107,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 13,
    "all_scales_index": 46
  },
  {
    "key": "1_1_1_2_1_1_1_2_1_1",
    "scaleNumber": 108,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 13,
    "all_scales_index": 85
  },
  {
    "key": "1_1_2_1_1_1_2_1_1_1",
    "scaleNumber": 109,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 13,
    "all_scales_index": 156
  },
  {
    "key": "1_2_1_1_1_2_1_1_1_1",
    "scaleNumber": 110,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 13,
    "all_scales_index": 287
  },
  {
    "key": "2_1_1_1_2_1_1_1_1_1",
    "scaleNumber": 111,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 13,
    "all_scales_index": 528
  },
  {
    "key": "1_1_1_2_1_1_1_1_1_2",
    "scaleNumber": 112,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 13,
    "all_scales_index": 82
  },
  {
    "key": "1_1_2_1_1_1_1_1_2_1",
    "scaleNumber": 113,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 13,
    "all_scales_index": 151
  },
  {
    "key": "1_2_1_1_1_1_1_2_1_1",
    "scaleNumber": 114,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 13,
    "all_scales_index": 278
  },
  {
    "key": "2_1_1_1_1_1_2_1_1_1",
    "scaleNumber": 115,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 10,
    "superscale_index": 13,
    "all_scales_index": 511
  },
  {
    "key": "1_1_1_1_1_2_1_1_3",
    "scaleNumber": 116,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 14,
    "all_scales_index": 27
  },
  {
    "key": "1_1_1_1_2_1_1_3_1",
    "scaleNumber": 117,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 14,
    "all_scales_index": 50
  },
  {
    "key": "1_1_1_2_1_1_3_1_1",
    "scaleNumber": 118,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 14,
    "all_scales_index": 92
  },
  {
    "key": "1_1_2_1_1_3_1_1_1",
    "scaleNumber": 119,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 14,
    "all_scales_index": 169
  },
  {
    "key": "1_2_1_1_3_1_1_1_1",
    "scaleNumber": 120,
    "scale": [
      1,
      2,
      1,
      1,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 14,
    "all_scales_index": 311
  },
  {
    "key": "2_1_1_3_1_1_1_1_1",
    "scaleNumber": 121,
    "scale": [
      2,
      1,
      1,
      3,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 14,
    "all_scales_index": 572
  },
  {
    "key": "1_1_3_1_1_1_1_1_2",
    "scaleNumber": 122,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 14,
    "all_scales_index": 231
  },
  {
    "key": "1_3_1_1_1_1_1_2_1",
    "scaleNumber": 123,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 14,
    "all_scales_index": 425
  },
  {
    "key": "3_1_1_1_1_1_2_1_1",
    "scaleNumber": 124,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 14,
    "all_scales_index": 782
  },
  {
    "key": "1_1_1_1_1_2_1_2_2",
    "scaleNumber": 125,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 15,
    "all_scales_index": 29
  },
  {
    "key": "1_1_1_1_2_1_2_2_1",
    "scaleNumber": 126,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 15,
    "all_scales_index": 53
  },
  {
    "key": "1_1_1_2_1_2_2_1_1",
    "scaleNumber": 127,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 15,
    "all_scales_index": 98
  },
  {
    "key": "1_1_2_1_2_2_1_1_1",
    "scaleNumber": 128,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 15,
    "all_scales_index": 180
  },
  {
    "key": "1_2_1_2_2_1_1_1_1",
    "scaleNumber": 129,
    "scale": [
      1,
      2,
      1,
      2,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 15,
    "all_scales_index": 331
  },
  {
    "key": "2_1_2_2_1_1_1_1_1",
    "scaleNumber": 130,
    "scale": [
      2,
      1,
      2,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 15,
    "all_scales_index": 609
  },
  {
    "key": "1_2_2_1_1_1_1_1_2",
    "scaleNumber": 131,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 15,
    "all_scales_index": 356
  },
  {
    "key": "2_2_1_1_1_1_1_2_1",
    "scaleNumber": 132,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 15,
    "all_scales_index": 655
  },
  {
    "key": "2_1_1_1_1_1_2_1_2",
    "scaleNumber": 133,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 15,
    "all_scales_index": 512
  },
  {
    "key": "1_1_1_1_1_2_2_1_2",
    "scaleNumber": 134,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 16,
    "all_scales_index": 32
  },
  {
    "key": "1_1_1_1_2_2_1_2_1",
    "scaleNumber": 135,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 16,
    "all_scales_index": 59
  },
  {
    "key": "1_1_1_2_2_1_2_1_1",
    "scaleNumber": 136,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 16,
    "all_scales_index": 109
  },
  {
    "key": "1_1_2_2_1_2_1_1_1",
    "scaleNumber": 137,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 16,
    "all_scales_index": 200
  },
  {
    "key": "1_2_2_1_2_1_1_1_1",
    "scaleNumber": 138,
    "scale": [
      1,
      2,
      2,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 16,
    "all_scales_index": 368
  },
  {
    "key": "2_2_1_2_1_1_1_1_1",
    "scaleNumber": 139,
    "scale": [
      2,
      2,
      1,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 16,
    "all_scales_index": 677
  },
  {
    "key": "2_1_2_1_1_1_1_1_2",
    "scaleNumber": 140,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 16,
    "all_scales_index": 586
  },
  {
    "key": "1_2_1_1_1_1_1_2_2",
    "scaleNumber": 141,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 16,
    "all_scales_index": 279
  },
  {
    "key": "2_1_1_1_1_1_2_2_1",
    "scaleNumber": 142,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 16,
    "all_scales_index": 513
  },
  {
    "key": "1_1_1_1_1_2_2_3",
    "scaleNumber": 143,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 17,
    "all_scales_index": 34
  },
  {
    "key": "1_1_1_1_2_2_3_1",
    "scaleNumber": 144,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 17,
    "all_scales_index": 63
  },
  {
    "key": "1_1_1_2_2_3_1_1",
    "scaleNumber": 145,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 17,
    "all_scales_index": 116
  },
  {
    "key": "1_1_2_2_3_1_1_1",
    "scaleNumber": 146,
    "scale": [
      1,
      1,
      2,
      2,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 17,
    "all_scales_index": 213
  },
  {
    "key": "1_2_2_3_1_1_1_1",
    "scaleNumber": 147,
    "scale": [
      1,
      2,
      2,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 17,
    "all_scales_index": 392
  },
  {
    "key": "2_2_3_1_1_1_1_1",
    "scaleNumber": 148,
    "scale": [
      2,
      2,
      3,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 17,
    "all_scales_index": 721
  },
  {
    "key": "2_3_1_1_1_1_1_2",
    "scaleNumber": 149,
    "scale": [
      2,
      3,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 17,
    "all_scales_index": 735
  },
  {
    "key": "3_1_1_1_1_1_2_2",
    "scaleNumber": 150,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 17,
    "all_scales_index": 783
  },
  {
    "key": "1_1_1_1_1_2_3_2",
    "scaleNumber": 151,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      2,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 18,
    "all_scales_index": 36
  },
  {
    "key": "1_1_1_1_2_3_2_1",
    "scaleNumber": 152,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 18,
    "all_scales_index": 66
  },
  {
    "key": "1_1_1_2_3_2_1_1",
    "scaleNumber": 153,
    "scale": [
      1,
      1,
      1,
      2,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 18,
    "all_scales_index": 122
  },
  {
    "key": "1_1_2_3_2_1_1_1",
    "scaleNumber": 154,
    "scale": [
      1,
      1,
      2,
      3,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 18,
    "all_scales_index": 224
  },
  {
    "key": "1_2_3_2_1_1_1_1",
    "scaleNumber": 155,
    "scale": [
      1,
      2,
      3,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 18,
    "all_scales_index": 412
  },
  {
    "key": "2_3_2_1_1_1_1_1",
    "scaleNumber": 156,
    "scale": [
      2,
      3,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 18,
    "all_scales_index": 758
  },
  {
    "key": "3_2_1_1_1_1_1_2",
    "scaleNumber": 157,
    "scale": [
      3,
      2,
      1,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 18,
    "all_scales_index": 860
  },
  {
    "key": "2_1_1_1_1_1_2_3",
    "scaleNumber": 158,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 18,
    "all_scales_index": 514
  },
  {
    "key": "1_1_1_1_1_3_1_1_2",
    "scaleNumber": 159,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      3,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 19,
    "all_scales_index": 38
  },
  {
    "key": "1_1_1_1_3_1_1_2_1",
    "scaleNumber": 160,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 19,
    "all_scales_index": 70
  },
  {
    "key": "1_1_1_3_1_1_2_1_1",
    "scaleNumber": 161,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 19,
    "all_scales_index": 129
  },
  {
    "key": "1_1_3_1_1_2_1_1_1",
    "scaleNumber": 162,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 19,
    "all_scales_index": 237
  },
  {
    "key": "1_3_1_1_2_1_1_1_1",
    "scaleNumber": 163,
    "scale": [
      1,
      3,
      1,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 19,
    "all_scales_index": 436
  },
  {
    "key": "3_1_1_2_1_1_1_1_1",
    "scaleNumber": 164,
    "scale": [
      3,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 19,
    "all_scales_index": 802
  },
  {
    "key": "1_1_2_1_1_1_1_1_3",
    "scaleNumber": 165,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 19,
    "all_scales_index": 152
  },
  {
    "key": "1_2_1_1_1_1_1_3_1",
    "scaleNumber": 166,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 19,
    "all_scales_index": 280
  },
  {
    "key": "2_1_1_1_1_1_3_1_1",
    "scaleNumber": 167,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 19,
    "all_scales_index": 515
  },
  {
    "key": "1_1_1_1_1_3_1_3",
    "scaleNumber": 168,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      3,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 20,
    "all_scales_index": 40
  },
  {
    "key": "1_1_1_1_3_1_3_1",
    "scaleNumber": 169,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 20,
    "all_scales_index": 74
  },
  {
    "key": "1_1_1_3_1_3_1_1",
    "scaleNumber": 170,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 20,
    "all_scales_index": 136
  },
  {
    "key": "1_1_3_1_3_1_1_1",
    "scaleNumber": 171,
    "scale": [
      1,
      1,
      3,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 20,
    "all_scales_index": 250
  },
  {
    "key": "1_3_1_3_1_1_1_1",
    "scaleNumber": 172,
    "scale": [
      1,
      3,
      1,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 20,
    "all_scales_index": 460
  },
  {
    "key": "3_1_3_1_1_1_1_1",
    "scaleNumber": 173,
    "scale": [
      3,
      1,
      3,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 20,
    "all_scales_index": 846
  },
  {
    "key": "1_3_1_1_1_1_1_3",
    "scaleNumber": 174,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 20,
    "all_scales_index": 426
  },
  {
    "key": "3_1_1_1_1_1_3_1",
    "scaleNumber": 175,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 20,
    "all_scales_index": 784
  },
  {
    "key": "1_1_1_1_1_3_2_2",
    "scaleNumber": 176,
    "scale": [
      1,
      1,
      1,
      1,
      1,
      3,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 21,
    "all_scales_index": 42
  },
  {
    "key": "1_1_1_1_3_2_2_1",
    "scaleNumber": 177,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 21,
    "all_scales_index": 77
  },
  {
    "key": "1_1_1_3_2_2_1_1",
    "scaleNumber": 178,
    "scale": [
      1,
      1,
      1,
      3,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 21,
    "all_scales_index": 142
  },
  {
    "key": "1_1_3_2_2_1_1_1",
    "scaleNumber": 179,
    "scale": [
      1,
      1,
      3,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 21,
    "all_scales_index": 261
  },
  {
    "key": "1_3_2_2_1_1_1_1",
    "scaleNumber": 180,
    "scale": [
      1,
      3,
      2,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 21,
    "all_scales_index": 480
  },
  {
    "key": "3_2_2_1_1_1_1_1",
    "scaleNumber": 181,
    "scale": [
      3,
      2,
      2,
      1,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 21,
    "all_scales_index": 883
  },
  {
    "key": "2_2_1_1_1_1_1_3",
    "scaleNumber": 182,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 21,
    "all_scales_index": 656
  },
  {
    "key": "2_1_1_1_1_1_3_2",
    "scaleNumber": 183,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 21,
    "all_scales_index": 516
  },
  {
    "key": "1_1_1_1_2_1_1_1_1_2",
    "scaleNumber": 184,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 22,
    "all_scales_index": 45
  },
  {
    "key": "1_1_1_2_1_1_1_1_2_1",
    "scaleNumber": 185,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 22,
    "all_scales_index": 83
  },
  {
    "key": "1_1_2_1_1_1_1_2_1_1",
    "scaleNumber": 186,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 22,
    "all_scales_index": 153
  },
  {
    "key": "1_2_1_1_1_1_2_1_1_1",
    "scaleNumber": 187,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 22,
    "all_scales_index": 281
  },
  {
    "key": "2_1_1_1_1_2_1_1_1_1",
    "scaleNumber": 188,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 22,
    "all_scales_index": 517
  },
  {
    "key": "1_1_1_1_2_1_1_1_3",
    "scaleNumber": 189,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 23,
    "all_scales_index": 47
  },
  {
    "key": "1_1_1_2_1_1_1_3_1",
    "scaleNumber": 190,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 23,
    "all_scales_index": 87
  },
  {
    "key": "1_1_2_1_1_1_3_1_1",
    "scaleNumber": 191,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 23,
    "all_scales_index": 160
  },
  {
    "key": "1_2_1_1_1_3_1_1_1",
    "scaleNumber": 192,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 23,
    "all_scales_index": 294
  },
  {
    "key": "2_1_1_1_3_1_1_1_1",
    "scaleNumber": 193,
    "scale": [
      2,
      1,
      1,
      1,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 23,
    "all_scales_index": 541
  },
  {
    "key": "1_1_1_3_1_1_1_1_2",
    "scaleNumber": 194,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 23,
    "all_scales_index": 126
  },
  {
    "key": "1_1_3_1_1_1_1_2_1",
    "scaleNumber": 195,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 23,
    "all_scales_index": 232
  },
  {
    "key": "1_3_1_1_1_1_2_1_1",
    "scaleNumber": 196,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 23,
    "all_scales_index": 427
  },
  {
    "key": "3_1_1_1_1_2_1_1_1",
    "scaleNumber": 197,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 23,
    "all_scales_index": 785
  },
  {
    "key": "1_1_1_1_2_1_1_2_2",
    "scaleNumber": 198,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 24,
    "all_scales_index": 49
  },
  {
    "key": "1_1_1_2_1_1_2_2_1",
    "scaleNumber": 199,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 24,
    "all_scales_index": 90
  },
  {
    "key": "1_1_2_1_1_2_2_1_1",
    "scaleNumber": 200,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 24,
    "all_scales_index": 166
  },
  {
    "key": "1_2_1_1_2_2_1_1_1",
    "scaleNumber": 201,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 24,
    "all_scales_index": 305
  },
  {
    "key": "2_1_1_2_2_1_1_1_1",
    "scaleNumber": 202,
    "scale": [
      2,
      1,
      1,
      2,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 24,
    "all_scales_index": 561
  },
  {
    "key": "1_1_2_2_1_1_1_1_2",
    "scaleNumber": 203,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 24,
    "all_scales_index": 194
  },
  {
    "key": "1_2_2_1_1_1_1_2_1",
    "scaleNumber": 204,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 24,
    "all_scales_index": 357
  },
  {
    "key": "2_2_1_1_1_1_2_1_1",
    "scaleNumber": 205,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 24,
    "all_scales_index": 657
  },
  {
    "key": "2_1_1_1_1_2_1_1_2",
    "scaleNumber": 206,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 24,
    "all_scales_index": 518
  },
  {
    "key": "1_1_1_1_2_1_2_1_2",
    "scaleNumber": 207,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 25,
    "all_scales_index": 52
  },
  {
    "key": "1_1_1_2_1_2_1_2_1",
    "scaleNumber": 208,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 25,
    "all_scales_index": 96
  },
  {
    "key": "1_1_2_1_2_1_2_1_1",
    "scaleNumber": 209,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 25,
    "all_scales_index": 177
  },
  {
    "key": "1_2_1_2_1_2_1_1_1",
    "scaleNumber": 210,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 25,
    "all_scales_index": 325
  },
  {
    "key": "2_1_2_1_2_1_1_1_1",
    "scaleNumber": 211,
    "scale": [
      2,
      1,
      2,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 25,
    "all_scales_index": 598
  },
  {
    "key": "1_2_1_2_1_1_1_1_2",
    "scaleNumber": 212,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 25,
    "all_scales_index": 319
  },
  {
    "key": "2_1_2_1_1_1_1_2_1",
    "scaleNumber": 213,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 25,
    "all_scales_index": 587
  },
  {
    "key": "1_2_1_1_1_1_2_1_2",
    "scaleNumber": 214,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 25,
    "all_scales_index": 282
  },
  {
    "key": "2_1_1_1_1_2_1_2_1",
    "scaleNumber": 215,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 25,
    "all_scales_index": 519
  },
  {
    "key": "1_1_1_1_2_1_2_3",
    "scaleNumber": 216,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 26,
    "all_scales_index": 54
  },
  {
    "key": "1_1_1_2_1_2_3_1",
    "scaleNumber": 217,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 26,
    "all_scales_index": 100
  },
  {
    "key": "1_1_2_1_2_3_1_1",
    "scaleNumber": 218,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 26,
    "all_scales_index": 184
  },
  {
    "key": "1_2_1_2_3_1_1_1",
    "scaleNumber": 219,
    "scale": [
      1,
      2,
      1,
      2,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 26,
    "all_scales_index": 338
  },
  {
    "key": "2_1_2_3_1_1_1_1",
    "scaleNumber": 220,
    "scale": [
      2,
      1,
      2,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 26,
    "all_scales_index": 622
  },
  {
    "key": "1_2_3_1_1_1_1_2",
    "scaleNumber": 221,
    "scale": [
      1,
      2,
      3,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 26,
    "all_scales_index": 400
  },
  {
    "key": "2_3_1_1_1_1_2_1",
    "scaleNumber": 222,
    "scale": [
      2,
      3,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 26,
    "all_scales_index": 736
  },
  {
    "key": "3_1_1_1_1_2_1_2",
    "scaleNumber": 223,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 26,
    "all_scales_index": 786
  },
  {
    "key": "1_1_1_1_2_1_3_2",
    "scaleNumber": 224,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 27,
    "all_scales_index": 56
  },
  {
    "key": "1_1_1_2_1_3_2_1",
    "scaleNumber": 225,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 27,
    "all_scales_index": 103
  },
  {
    "key": "1_1_2_1_3_2_1_1",
    "scaleNumber": 226,
    "scale": [
      1,
      1,
      2,
      1,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 27,
    "all_scales_index": 190
  },
  {
    "key": "1_2_1_3_2_1_1_1",
    "scaleNumber": 227,
    "scale": [
      1,
      2,
      1,
      3,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 27,
    "all_scales_index": 349
  },
  {
    "key": "2_1_3_2_1_1_1_1",
    "scaleNumber": 228,
    "scale": [
      2,
      1,
      3,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 27,
    "all_scales_index": 642
  },
  {
    "key": "1_3_2_1_1_1_1_2",
    "scaleNumber": 229,
    "scale": [
      1,
      3,
      2,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 27,
    "all_scales_index": 468
  },
  {
    "key": "3_2_1_1_1_1_2_1",
    "scaleNumber": 230,
    "scale": [
      3,
      2,
      1,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 27,
    "all_scales_index": 861
  },
  {
    "key": "2_1_1_1_1_2_1_3",
    "scaleNumber": 231,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 27,
    "all_scales_index": 520
  },
  {
    "key": "1_1_1_1_2_2_1_1_2",
    "scaleNumber": 232,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 28,
    "all_scales_index": 58
  },
  {
    "key": "1_1_1_2_2_1_1_2_1",
    "scaleNumber": 233,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 28,
    "all_scales_index": 107
  },
  {
    "key": "1_1_2_2_1_1_2_1_1",
    "scaleNumber": 234,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 28,
    "all_scales_index": 197
  },
  {
    "key": "1_2_2_1_1_2_1_1_1",
    "scaleNumber": 235,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 28,
    "all_scales_index": 362
  },
  {
    "key": "2_2_1_1_2_1_1_1_1",
    "scaleNumber": 236,
    "scale": [
      2,
      2,
      1,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 28,
    "all_scales_index": 666
  },
  {
    "key": "2_1_1_2_1_1_1_1_2",
    "scaleNumber": 237,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 28,
    "all_scales_index": 549
  },
  {
    "key": "1_1_2_1_1_1_1_2_2",
    "scaleNumber": 238,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 28,
    "all_scales_index": 154
  },
  {
    "key": "1_2_1_1_1_1_2_2_1",
    "scaleNumber": 239,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 28,
    "all_scales_index": 283
  },
  {
    "key": "2_1_1_1_1_2_2_1_1",
    "scaleNumber": 240,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 28,
    "all_scales_index": 521
  },
  {
    "key": "1_1_1_1_2_2_1_3",
    "scaleNumber": 241,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 29,
    "all_scales_index": 60
  },
  {
    "key": "1_1_1_2_2_1_3_1",
    "scaleNumber": 242,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 29,
    "all_scales_index": 111
  },
  {
    "key": "1_1_2_2_1_3_1_1",
    "scaleNumber": 243,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 29,
    "all_scales_index": 204
  },
  {
    "key": "1_2_2_1_3_1_1_1",
    "scaleNumber": 244,
    "scale": [
      1,
      2,
      2,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 29,
    "all_scales_index": 375
  },
  {
    "key": "2_2_1_3_1_1_1_1",
    "scaleNumber": 245,
    "scale": [
      2,
      2,
      1,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 29,
    "all_scales_index": 690
  },
  {
    "key": "2_1_3_1_1_1_1_2",
    "scaleNumber": 246,
    "scale": [
      2,
      1,
      3,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 29,
    "all_scales_index": 630
  },
  {
    "key": "1_3_1_1_1_1_2_2",
    "scaleNumber": 247,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 29,
    "all_scales_index": 428
  },
  {
    "key": "3_1_1_1_1_2_2_1",
    "scaleNumber": 248,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 29,
    "all_scales_index": 787
  },
  {
    "key": "1_1_1_1_2_2_2_2",
    "scaleNumber": 249,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 30,
    "all_scales_index": 62
  },
  {
    "key": "1_1_1_2_2_2_2_1",
    "scaleNumber": 250,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 30,
    "all_scales_index": 114
  },
  {
    "key": "1_1_2_2_2_2_1_1",
    "scaleNumber": 251,
    "scale": [
      1,
      1,
      2,
      2,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 30,
    "all_scales_index": 210
  },
  {
    "key": "1_2_2_2_2_1_1_1",
    "scaleNumber": 252,
    "scale": [
      1,
      2,
      2,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 30,
    "all_scales_index": 386
  },
  {
    "key": "2_2_2_2_1_1_1_1",
    "scaleNumber": 253,
    "scale": [
      2,
      2,
      2,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 30,
    "all_scales_index": 710
  },
  {
    "key": "2_2_2_1_1_1_1_2",
    "scaleNumber": 254,
    "scale": [
      2,
      2,
      2,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 30,
    "all_scales_index": 698
  },
  {
    "key": "2_2_1_1_1_1_2_2",
    "scaleNumber": 255,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 30,
    "all_scales_index": 658
  },
  {
    "key": "2_1_1_1_1_2_2_2",
    "scaleNumber": 256,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 30,
    "all_scales_index": 522
  },
  {
    "key": "1_1_1_1_2_3_1_2",
    "scaleNumber": 257,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      3,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 31,
    "all_scales_index": 65
  },
  {
    "key": "1_1_1_2_3_1_2_1",
    "scaleNumber": 258,
    "scale": [
      1,
      1,
      1,
      2,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 31,
    "all_scales_index": 120
  },
  {
    "key": "1_1_2_3_1_2_1_1",
    "scaleNumber": 259,
    "scale": [
      1,
      1,
      2,
      3,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 31,
    "all_scales_index": 221
  },
  {
    "key": "1_2_3_1_2_1_1_1",
    "scaleNumber": 260,
    "scale": [
      1,
      2,
      3,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 31,
    "all_scales_index": 406
  },
  {
    "key": "2_3_1_2_1_1_1_1",
    "scaleNumber": 261,
    "scale": [
      2,
      3,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 31,
    "all_scales_index": 747
  },
  {
    "key": "3_1_2_1_1_1_1_2",
    "scaleNumber": 262,
    "scale": [
      3,
      1,
      2,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 31,
    "all_scales_index": 823
  },
  {
    "key": "1_2_1_1_1_1_2_3",
    "scaleNumber": 263,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 31,
    "all_scales_index": 284
  },
  {
    "key": "2_1_1_1_1_2_3_1",
    "scaleNumber": 264,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 31,
    "all_scales_index": 523
  },
  {
    "key": "1_1_1_1_2_3_3",
    "scaleNumber": 265,
    "scale": [
      1,
      1,
      1,
      1,
      2,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 32,
    "all_scales_index": 67
  },
  {
    "key": "1_1_1_2_3_3_1",
    "scaleNumber": 266,
    "scale": [
      1,
      1,
      1,
      2,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 32,
    "all_scales_index": 124
  },
  {
    "key": "1_1_2_3_3_1_1",
    "scaleNumber": 267,
    "scale": [
      1,
      1,
      2,
      3,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 32,
    "all_scales_index": 228
  },
  {
    "key": "1_2_3_3_1_1_1",
    "scaleNumber": 268,
    "scale": [
      1,
      2,
      3,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 32,
    "all_scales_index": 419
  },
  {
    "key": "2_3_3_1_1_1_1",
    "scaleNumber": 269,
    "scale": [
      2,
      3,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 32,
    "all_scales_index": 771
  },
  {
    "key": "3_3_1_1_1_1_2",
    "scaleNumber": 270,
    "scale": [
      3,
      3,
      1,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 32,
    "all_scales_index": 904
  },
  {
    "key": "3_1_1_1_1_2_3",
    "scaleNumber": 271,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 32,
    "all_scales_index": 788
  },
  {
    "key": "1_1_1_1_3_1_1_1_2",
    "scaleNumber": 272,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      1,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 33,
    "all_scales_index": 69
  },
  {
    "key": "1_1_1_3_1_1_1_2_1",
    "scaleNumber": 273,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 33,
    "all_scales_index": 127
  },
  {
    "key": "1_1_3_1_1_1_2_1_1",
    "scaleNumber": 274,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 33,
    "all_scales_index": 234
  },
  {
    "key": "1_3_1_1_1_2_1_1_1",
    "scaleNumber": 275,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 33,
    "all_scales_index": 430
  },
  {
    "key": "3_1_1_1_2_1_1_1_1",
    "scaleNumber": 276,
    "scale": [
      3,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 33,
    "all_scales_index": 791
  },
  {
    "key": "1_1_1_2_1_1_1_1_3",
    "scaleNumber": 277,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 33,
    "all_scales_index": 84
  },
  {
    "key": "1_1_2_1_1_1_1_3_1",
    "scaleNumber": 278,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 33,
    "all_scales_index": 155
  },
  {
    "key": "1_2_1_1_1_1_3_1_1",
    "scaleNumber": 279,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 33,
    "all_scales_index": 285
  },
  {
    "key": "2_1_1_1_1_3_1_1_1",
    "scaleNumber": 280,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 33,
    "all_scales_index": 524
  },
  {
    "key": "1_1_1_1_3_1_1_3",
    "scaleNumber": 281,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      1,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 34,
    "all_scales_index": 71
  },
  {
    "key": "1_1_1_3_1_1_3_1",
    "scaleNumber": 282,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 34,
    "all_scales_index": 131
  },
  {
    "key": "1_1_3_1_1_3_1_1",
    "scaleNumber": 283,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 34,
    "all_scales_index": 241
  },
  {
    "key": "1_3_1_1_3_1_1_1",
    "scaleNumber": 284,
    "scale": [
      1,
      3,
      1,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 34,
    "all_scales_index": 443
  },
  {
    "key": "3_1_1_3_1_1_1_1",
    "scaleNumber": 285,
    "scale": [
      3,
      1,
      1,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 34,
    "all_scales_index": 815
  },
  {
    "key": "1_1_3_1_1_1_1_3",
    "scaleNumber": 286,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 34,
    "all_scales_index": 233
  },
  {
    "key": "1_3_1_1_1_1_3_1",
    "scaleNumber": 287,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 34,
    "all_scales_index": 429
  },
  {
    "key": "3_1_1_1_1_3_1_1",
    "scaleNumber": 288,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 34,
    "all_scales_index": 789
  },
  {
    "key": "1_1_1_1_3_1_2_2",
    "scaleNumber": 289,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 35,
    "all_scales_index": 73
  },
  {
    "key": "1_1_1_3_1_2_2_1",
    "scaleNumber": 290,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 35,
    "all_scales_index": 134
  },
  {
    "key": "1_1_3_1_2_2_1_1",
    "scaleNumber": 291,
    "scale": [
      1,
      1,
      3,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 35,
    "all_scales_index": 247
  },
  {
    "key": "1_3_1_2_2_1_1_1",
    "scaleNumber": 292,
    "scale": [
      1,
      3,
      1,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 35,
    "all_scales_index": 454
  },
  {
    "key": "3_1_2_2_1_1_1_1",
    "scaleNumber": 293,
    "scale": [
      3,
      1,
      2,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 35,
    "all_scales_index": 835
  },
  {
    "key": "1_2_2_1_1_1_1_3",
    "scaleNumber": 294,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 35,
    "all_scales_index": 358
  },
  {
    "key": "2_2_1_1_1_1_3_1",
    "scaleNumber": 295,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 35,
    "all_scales_index": 659
  },
  {
    "key": "2_1_1_1_1_3_1_2",
    "scaleNumber": 296,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 35,
    "all_scales_index": 525
  },
  {
    "key": "1_1_1_1_3_2_1_2",
    "scaleNumber": 297,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 36,
    "all_scales_index": 76
  },
  {
    "key": "1_1_1_3_2_1_2_1",
    "scaleNumber": 298,
    "scale": [
      1,
      1,
      1,
      3,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 36,
    "all_scales_index": 140
  },
  {
    "key": "1_1_3_2_1_2_1_1",
    "scaleNumber": 299,
    "scale": [
      1,
      1,
      3,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 36,
    "all_scales_index": 258
  },
  {
    "key": "1_3_2_1_2_1_1_1",
    "scaleNumber": 300,
    "scale": [
      1,
      3,
      2,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 36,
    "all_scales_index": 474
  },
  {
    "key": "3_2_1_2_1_1_1_1",
    "scaleNumber": 301,
    "scale": [
      3,
      2,
      1,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 36,
    "all_scales_index": 872
  },
  {
    "key": "2_1_2_1_1_1_1_3",
    "scaleNumber": 302,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 36,
    "all_scales_index": 588
  },
  {
    "key": "1_2_1_1_1_1_3_2",
    "scaleNumber": 303,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 36,
    "all_scales_index": 286
  },
  {
    "key": "2_1_1_1_1_3_2_1",
    "scaleNumber": 304,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 36,
    "all_scales_index": 526
  },
  {
    "key": "1_1_1_1_3_2_3",
    "scaleNumber": 305,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 37,
    "all_scales_index": 78
  },
  {
    "key": "1_1_1_3_2_3_1",
    "scaleNumber": 306,
    "scale": [
      1,
      1,
      1,
      3,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 37,
    "all_scales_index": 144
  },
  {
    "key": "1_1_3_2_3_1_1",
    "scaleNumber": 307,
    "scale": [
      1,
      1,
      3,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 37,
    "all_scales_index": 265
  },
  {
    "key": "1_3_2_3_1_1_1",
    "scaleNumber": 308,
    "scale": [
      1,
      3,
      2,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 37,
    "all_scales_index": 487
  },
  {
    "key": "3_2_3_1_1_1_1",
    "scaleNumber": 309,
    "scale": [
      3,
      2,
      3,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 37,
    "all_scales_index": 896
  },
  {
    "key": "2_3_1_1_1_1_3",
    "scaleNumber": 310,
    "scale": [
      2,
      3,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 37,
    "all_scales_index": 737
  },
  {
    "key": "3_1_1_1_1_3_2",
    "scaleNumber": 311,
    "scale": [
      3,
      1,
      1,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 37,
    "all_scales_index": 790
  },
  {
    "key": "1_1_1_1_3_3_2",
    "scaleNumber": 312,
    "scale": [
      1,
      1,
      1,
      1,
      3,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 38,
    "all_scales_index": 80
  },
  {
    "key": "1_1_1_3_3_2_1",
    "scaleNumber": 313,
    "scale": [
      1,
      1,
      1,
      3,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 38,
    "all_scales_index": 147
  },
  {
    "key": "1_1_3_3_2_1_1",
    "scaleNumber": 314,
    "scale": [
      1,
      1,
      3,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 38,
    "all_scales_index": 271
  },
  {
    "key": "1_3_3_2_1_1_1",
    "scaleNumber": 315,
    "scale": [
      1,
      3,
      3,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 38,
    "all_scales_index": 498
  },
  {
    "key": "3_3_2_1_1_1_1",
    "scaleNumber": 316,
    "scale": [
      3,
      3,
      2,
      1,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 38,
    "all_scales_index": 916
  },
  {
    "key": "3_2_1_1_1_1_3",
    "scaleNumber": 317,
    "scale": [
      3,
      2,
      1,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 38,
    "all_scales_index": 862
  },
  {
    "key": "2_1_1_1_1_3_3",
    "scaleNumber": 318,
    "scale": [
      2,
      1,
      1,
      1,
      1,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 38,
    "all_scales_index": 527
  },
  {
    "key": "1_1_1_2_1_1_1_2_2",
    "scaleNumber": 319,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 39,
    "all_scales_index": 86
  },
  {
    "key": "1_1_2_1_1_1_2_2_1",
    "scaleNumber": 320,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 39,
    "all_scales_index": 158
  },
  {
    "key": "1_2_1_1_1_2_2_1_1",
    "scaleNumber": 321,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 39,
    "all_scales_index": 291
  },
  {
    "key": "2_1_1_1_2_2_1_1_1",
    "scaleNumber": 322,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 39,
    "all_scales_index": 535
  },
  {
    "key": "1_1_1_2_2_1_1_1_2",
    "scaleNumber": 323,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 39,
    "all_scales_index": 106
  },
  {
    "key": "1_1_2_2_1_1_1_2_1",
    "scaleNumber": 324,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 39,
    "all_scales_index": 195
  },
  {
    "key": "1_2_2_1_1_1_2_1_1",
    "scaleNumber": 325,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 39,
    "all_scales_index": 359
  },
  {
    "key": "2_2_1_1_1_2_1_1_1",
    "scaleNumber": 326,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 39,
    "all_scales_index": 660
  },
  {
    "key": "2_1_1_1_2_1_1_1_2",
    "scaleNumber": 327,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 39,
    "all_scales_index": 529
  },
  {
    "key": "1_1_1_2_1_1_2_1_2",
    "scaleNumber": 328,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 40,
    "all_scales_index": 89
  },
  {
    "key": "1_1_2_1_1_2_1_2_1",
    "scaleNumber": 329,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 40,
    "all_scales_index": 164
  },
  {
    "key": "1_2_1_1_2_1_2_1_1",
    "scaleNumber": 330,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 40,
    "all_scales_index": 302
  },
  {
    "key": "2_1_1_2_1_2_1_1_1",
    "scaleNumber": 331,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 40,
    "all_scales_index": 555
  },
  {
    "key": "1_1_2_1_2_1_1_1_2",
    "scaleNumber": 332,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 40,
    "all_scales_index": 174
  },
  {
    "key": "1_2_1_2_1_1_1_2_1",
    "scaleNumber": 333,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 40,
    "all_scales_index": 320
  },
  {
    "key": "2_1_2_1_1_1_2_1_1",
    "scaleNumber": 334,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 40,
    "all_scales_index": 589
  },
  {
    "key": "1_2_1_1_1_2_1_1_2",
    "scaleNumber": 335,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 40,
    "all_scales_index": 288
  },
  {
    "key": "2_1_1_1_2_1_1_2_1",
    "scaleNumber": 336,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 40,
    "all_scales_index": 530
  },
  {
    "key": "1_1_1_2_1_1_2_3",
    "scaleNumber": 337,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 41,
    "all_scales_index": 91
  },
  {
    "key": "1_1_2_1_1_2_3_1",
    "scaleNumber": 338,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 41,
    "all_scales_index": 168
  },
  {
    "key": "1_2_1_1_2_3_1_1",
    "scaleNumber": 339,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 41,
    "all_scales_index": 309
  },
  {
    "key": "2_1_1_2_3_1_1_1",
    "scaleNumber": 340,
    "scale": [
      2,
      1,
      1,
      2,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 41,
    "all_scales_index": 568
  },
  {
    "key": "1_1_2_3_1_1_1_2",
    "scaleNumber": 341,
    "scale": [
      1,
      1,
      2,
      3,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 41,
    "all_scales_index": 218
  },
  {
    "key": "1_2_3_1_1_1_2_1",
    "scaleNumber": 342,
    "scale": [
      1,
      2,
      3,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 41,
    "all_scales_index": 401
  },
  {
    "key": "2_3_1_1_1_2_1_1",
    "scaleNumber": 343,
    "scale": [
      2,
      3,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 41,
    "all_scales_index": 738
  },
  {
    "key": "3_1_1_1_2_1_1_2",
    "scaleNumber": 344,
    "scale": [
      3,
      1,
      1,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 41,
    "all_scales_index": 792
  },
  {
    "key": "1_1_1_2_1_1_3_2",
    "scaleNumber": 345,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 42,
    "all_scales_index": 93
  },
  {
    "key": "1_1_2_1_1_3_2_1",
    "scaleNumber": 346,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 42,
    "all_scales_index": 171
  },
  {
    "key": "1_2_1_1_3_2_1_1",
    "scaleNumber": 347,
    "scale": [
      1,
      2,
      1,
      1,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 42,
    "all_scales_index": 315
  },
  {
    "key": "2_1_1_3_2_1_1_1",
    "scaleNumber": 348,
    "scale": [
      2,
      1,
      1,
      3,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 42,
    "all_scales_index": 579
  },
  {
    "key": "1_1_3_2_1_1_1_2",
    "scaleNumber": 349,
    "scale": [
      1,
      1,
      3,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 42,
    "all_scales_index": 255
  },
  {
    "key": "1_3_2_1_1_1_2_1",
    "scaleNumber": 350,
    "scale": [
      1,
      3,
      2,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 42,
    "all_scales_index": 469
  },
  {
    "key": "3_2_1_1_1_2_1_1",
    "scaleNumber": 351,
    "scale": [
      3,
      2,
      1,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 42,
    "all_scales_index": 863
  },
  {
    "key": "2_1_1_1_2_1_1_3",
    "scaleNumber": 352,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 42,
    "all_scales_index": 531
  },
  {
    "key": "1_1_1_2_1_2_1_1_2",
    "scaleNumber": 353,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 43,
    "all_scales_index": 95
  },
  {
    "key": "1_1_2_1_2_1_1_2_1",
    "scaleNumber": 354,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 43,
    "all_scales_index": 175
  },
  {
    "key": "1_2_1_2_1_1_2_1_1",
    "scaleNumber": 355,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 43,
    "all_scales_index": 322
  },
  {
    "key": "2_1_2_1_1_2_1_1_1",
    "scaleNumber": 356,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 43,
    "all_scales_index": 592
  },
  {
    "key": "1_2_1_1_2_1_1_1_2",
    "scaleNumber": 357,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 43,
    "all_scales_index": 299
  },
  {
    "key": "2_1_1_2_1_1_1_2_1",
    "scaleNumber": 358,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 43,
    "all_scales_index": 550
  },
  {
    "key": "1_1_2_1_1_1_2_1_2",
    "scaleNumber": 359,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 43,
    "all_scales_index": 157
  },
  {
    "key": "1_2_1_1_1_2_1_2_1",
    "scaleNumber": 360,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 43,
    "all_scales_index": 289
  },
  {
    "key": "2_1_1_1_2_1_2_1_1",
    "scaleNumber": 361,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 9,
    "superscale_index": 43,
    "all_scales_index": 532
  },
  {
    "key": "1_1_1_2_1_2_1_3",
    "scaleNumber": 362,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 44,
    "all_scales_index": 97
  },
  {
    "key": "1_1_2_1_2_1_3_1",
    "scaleNumber": 363,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 44,
    "all_scales_index": 179
  },
  {
    "key": "1_2_1_2_1_3_1_1",
    "scaleNumber": 364,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 44,
    "all_scales_index": 329
  },
  {
    "key": "2_1_2_1_3_1_1_1",
    "scaleNumber": 365,
    "scale": [
      2,
      1,
      2,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 44,
    "all_scales_index": 605
  },
  {
    "key": "1_2_1_3_1_1_1_2",
    "scaleNumber": 366,
    "scale": [
      1,
      2,
      1,
      3,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 44,
    "all_scales_index": 343
  },
  {
    "key": "2_1_3_1_1_1_2_1",
    "scaleNumber": 367,
    "scale": [
      2,
      1,
      3,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 44,
    "all_scales_index": 631
  },
  {
    "key": "1_3_1_1_1_2_1_2",
    "scaleNumber": 368,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 44,
    "all_scales_index": 431
  },
  {
    "key": "3_1_1_1_2_1_2_1",
    "scaleNumber": 369,
    "scale": [
      3,
      1,
      1,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 44,
    "all_scales_index": 793
  },
  {
    "key": "1_1_1_2_1_2_2_2",
    "scaleNumber": 370,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 45,
    "all_scales_index": 99
  },
  {
    "key": "1_1_2_1_2_2_2_1",
    "scaleNumber": 371,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 45,
    "all_scales_index": 182
  },
  {
    "key": "1_2_1_2_2_2_1_1",
    "scaleNumber": 372,
    "scale": [
      1,
      2,
      1,
      2,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 45,
    "all_scales_index": 335
  },
  {
    "key": "2_1_2_2_2_1_1_1",
    "scaleNumber": 373,
    "scale": [
      2,
      1,
      2,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 45,
    "all_scales_index": 616
  },
  {
    "key": "1_2_2_2_1_1_1_2",
    "scaleNumber": 374,
    "scale": [
      1,
      2,
      2,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 45,
    "all_scales_index": 380
  },
  {
    "key": "2_2_2_1_1_1_2_1",
    "scaleNumber": 375,
    "scale": [
      2,
      2,
      2,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 45,
    "all_scales_index": 699
  },
  {
    "key": "2_2_1_1_1_2_1_2",
    "scaleNumber": 376,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 45,
    "all_scales_index": 661
  },
  {
    "key": "2_1_1_1_2_1_2_2",
    "scaleNumber": 377,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 45,
    "all_scales_index": 533
  },
  {
    "key": "1_1_1_2_1_3_1_2",
    "scaleNumber": 378,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      3,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 46,
    "all_scales_index": 102
  },
  {
    "key": "1_1_2_1_3_1_2_1",
    "scaleNumber": 379,
    "scale": [
      1,
      1,
      2,
      1,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 46,
    "all_scales_index": 188
  },
  {
    "key": "1_2_1_3_1_2_1_1",
    "scaleNumber": 380,
    "scale": [
      1,
      2,
      1,
      3,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 46,
    "all_scales_index": 346
  },
  {
    "key": "2_1_3_1_2_1_1_1",
    "scaleNumber": 381,
    "scale": [
      2,
      1,
      3,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 46,
    "all_scales_index": 636
  },
  {
    "key": "1_3_1_2_1_1_1_2",
    "scaleNumber": 382,
    "scale": [
      1,
      3,
      1,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 46,
    "all_scales_index": 448
  },
  {
    "key": "3_1_2_1_1_1_2_1",
    "scaleNumber": 383,
    "scale": [
      3,
      1,
      2,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 46,
    "all_scales_index": 824
  },
  {
    "key": "1_2_1_1_1_2_1_3",
    "scaleNumber": 384,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 46,
    "all_scales_index": 290
  },
  {
    "key": "2_1_1_1_2_1_3_1",
    "scaleNumber": 385,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 46,
    "all_scales_index": 534
  },
  {
    "key": "1_1_1_2_1_3_3",
    "scaleNumber": 386,
    "scale": [
      1,
      1,
      1,
      2,
      1,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 47,
    "all_scales_index": 104
  },
  {
    "key": "1_1_2_1_3_3_1",
    "scaleNumber": 387,
    "scale": [
      1,
      1,
      2,
      1,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 47,
    "all_scales_index": 192
  },
  {
    "key": "1_2_1_3_3_1_1",
    "scaleNumber": 388,
    "scale": [
      1,
      2,
      1,
      3,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 47,
    "all_scales_index": 353
  },
  {
    "key": "2_1_3_3_1_1_1",
    "scaleNumber": 389,
    "scale": [
      2,
      1,
      3,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 47,
    "all_scales_index": 649
  },
  {
    "key": "1_3_3_1_1_1_2",
    "scaleNumber": 390,
    "scale": [
      1,
      3,
      3,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 47,
    "all_scales_index": 492
  },
  {
    "key": "3_3_1_1_1_2_1",
    "scaleNumber": 391,
    "scale": [
      3,
      3,
      1,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 47,
    "all_scales_index": 905
  },
  {
    "key": "3_1_1_1_2_1_3",
    "scaleNumber": 392,
    "scale": [
      3,
      1,
      1,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 47,
    "all_scales_index": 794
  },
  {
    "key": "1_1_1_2_2_1_1_3",
    "scaleNumber": 393,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      1,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 48,
    "all_scales_index": 108
  },
  {
    "key": "1_1_2_2_1_1_3_1",
    "scaleNumber": 394,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 48,
    "all_scales_index": 199
  },
  {
    "key": "1_2_2_1_1_3_1_1",
    "scaleNumber": 395,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 48,
    "all_scales_index": 366
  },
  {
    "key": "2_2_1_1_3_1_1_1",
    "scaleNumber": 396,
    "scale": [
      2,
      2,
      1,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 48,
    "all_scales_index": 673
  },
  {
    "key": "2_1_1_3_1_1_1_2",
    "scaleNumber": 397,
    "scale": [
      2,
      1,
      1,
      3,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 48,
    "all_scales_index": 573
  },
  {
    "key": "1_1_3_1_1_1_2_2",
    "scaleNumber": 398,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 48,
    "all_scales_index": 235
  },
  {
    "key": "1_3_1_1_1_2_2_1",
    "scaleNumber": 399,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 48,
    "all_scales_index": 432
  },
  {
    "key": "3_1_1_1_2_2_1_1",
    "scaleNumber": 400,
    "scale": [
      3,
      1,
      1,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 48,
    "all_scales_index": 795
  },
  {
    "key": "1_1_1_2_2_1_2_2",
    "scaleNumber": 401,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 49,
    "all_scales_index": 110
  },
  {
    "key": "1_1_2_2_1_2_2_1",
    "scaleNumber": 402,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 49,
    "all_scales_index": 202
  },
  {
    "key": "1_2_2_1_2_2_1_1",
    "scaleNumber": 403,
    "scale": [
      1,
      2,
      2,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 49,
    "all_scales_index": 372
  },
  {
    "key": "2_2_1_2_2_1_1_1",
    "scaleNumber": 404,
    "scale": [
      2,
      2,
      1,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 49,
    "all_scales_index": 684
  },
  {
    "key": "2_1_2_2_1_1_1_2",
    "scaleNumber": 405,
    "scale": [
      2,
      1,
      2,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 49,
    "all_scales_index": 610
  },
  {
    "key": "1_2_2_1_1_1_2_2",
    "scaleNumber": 406,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 49,
    "all_scales_index": 360
  },
  {
    "key": "2_2_1_1_1_2_2_1",
    "scaleNumber": 407,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 49,
    "all_scales_index": 662
  },
  {
    "key": "2_1_1_1_2_2_1_2",
    "scaleNumber": 408,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 49,
    "all_scales_index": 536
  },
  {
    "key": "1_1_1_2_2_2_1_2",
    "scaleNumber": 409,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 50,
    "all_scales_index": 113
  },
  {
    "key": "1_1_2_2_2_1_2_1",
    "scaleNumber": 410,
    "scale": [
      1,
      1,
      2,
      2,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 50,
    "all_scales_index": 208
  },
  {
    "key": "1_2_2_2_1_2_1_1",
    "scaleNumber": 411,
    "scale": [
      1,
      2,
      2,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 50,
    "all_scales_index": 383
  },
  {
    "key": "2_2_2_1_2_1_1_1",
    "scaleNumber": 412,
    "scale": [
      2,
      2,
      2,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 50,
    "all_scales_index": 704
  },
  {
    "key": "2_2_1_2_1_1_1_2",
    "scaleNumber": 413,
    "scale": [
      2,
      2,
      1,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 50,
    "all_scales_index": 678
  },
  {
    "key": "2_1_2_1_1_1_2_2",
    "scaleNumber": 414,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 50,
    "all_scales_index": 590
  },
  {
    "key": "1_2_1_1_1_2_2_2",
    "scaleNumber": 415,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 50,
    "all_scales_index": 292
  },
  {
    "key": "2_1_1_1_2_2_2_1",
    "scaleNumber": 416,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 50,
    "all_scales_index": 537
  },
  {
    "key": "1_1_1_2_2_2_3",
    "scaleNumber": 417,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 51,
    "all_scales_index": 115
  },
  {
    "key": "1_1_2_2_2_3_1",
    "scaleNumber": 418,
    "scale": [
      1,
      1,
      2,
      2,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 51,
    "all_scales_index": 212
  },
  {
    "key": "1_2_2_2_3_1_1",
    "scaleNumber": 419,
    "scale": [
      1,
      2,
      2,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 51,
    "all_scales_index": 390
  },
  {
    "key": "2_2_2_3_1_1_1",
    "scaleNumber": 420,
    "scale": [
      2,
      2,
      2,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 51,
    "all_scales_index": 717
  },
  {
    "key": "2_2_3_1_1_1_2",
    "scaleNumber": 421,
    "scale": [
      2,
      2,
      3,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 51,
    "all_scales_index": 722
  },
  {
    "key": "2_3_1_1_1_2_2",
    "scaleNumber": 422,
    "scale": [
      2,
      3,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 51,
    "all_scales_index": 739
  },
  {
    "key": "3_1_1_1_2_2_2",
    "scaleNumber": 423,
    "scale": [
      3,
      1,
      1,
      1,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 51,
    "all_scales_index": 796
  },
  {
    "key": "1_1_1_2_2_3_2",
    "scaleNumber": 424,
    "scale": [
      1,
      1,
      1,
      2,
      2,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 52,
    "all_scales_index": 117
  },
  {
    "key": "1_1_2_2_3_2_1",
    "scaleNumber": 425,
    "scale": [
      1,
      1,
      2,
      2,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 52,
    "all_scales_index": 215
  },
  {
    "key": "1_2_2_3_2_1_1",
    "scaleNumber": 426,
    "scale": [
      1,
      2,
      2,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 52,
    "all_scales_index": 396
  },
  {
    "key": "2_2_3_2_1_1_1",
    "scaleNumber": 427,
    "scale": [
      2,
      2,
      3,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 52,
    "all_scales_index": 728
  },
  {
    "key": "2_3_2_1_1_1_2",
    "scaleNumber": 428,
    "scale": [
      2,
      3,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 52,
    "all_scales_index": 759
  },
  {
    "key": "3_2_1_1_1_2_2",
    "scaleNumber": 429,
    "scale": [
      3,
      2,
      1,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 52,
    "all_scales_index": 864
  },
  {
    "key": "2_1_1_1_2_2_3",
    "scaleNumber": 430,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 52,
    "all_scales_index": 538
  },
  {
    "key": "1_1_1_2_3_1_1_2",
    "scaleNumber": 431,
    "scale": [
      1,
      1,
      1,
      2,
      3,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 53,
    "all_scales_index": 119
  },
  {
    "key": "1_1_2_3_1_1_2_1",
    "scaleNumber": 432,
    "scale": [
      1,
      1,
      2,
      3,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 53,
    "all_scales_index": 219
  },
  {
    "key": "1_2_3_1_1_2_1_1",
    "scaleNumber": 433,
    "scale": [
      1,
      2,
      3,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 53,
    "all_scales_index": 403
  },
  {
    "key": "2_3_1_1_2_1_1_1",
    "scaleNumber": 434,
    "scale": [
      2,
      3,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 53,
    "all_scales_index": 741
  },
  {
    "key": "3_1_1_2_1_1_1_2",
    "scaleNumber": 435,
    "scale": [
      3,
      1,
      1,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 53,
    "all_scales_index": 803
  },
  {
    "key": "1_1_2_1_1_1_2_3",
    "scaleNumber": 436,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 53,
    "all_scales_index": 159
  },
  {
    "key": "1_2_1_1_1_2_3_1",
    "scaleNumber": 437,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 53,
    "all_scales_index": 293
  },
  {
    "key": "2_1_1_1_2_3_1_1",
    "scaleNumber": 438,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 53,
    "all_scales_index": 539
  },
  {
    "key": "1_1_1_2_3_1_3",
    "scaleNumber": 439,
    "scale": [
      1,
      1,
      1,
      2,
      3,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 54,
    "all_scales_index": 121
  },
  {
    "key": "1_1_2_3_1_3_1",
    "scaleNumber": 440,
    "scale": [
      1,
      1,
      2,
      3,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 54,
    "all_scales_index": 223
  },
  {
    "key": "1_2_3_1_3_1_1",
    "scaleNumber": 441,
    "scale": [
      1,
      2,
      3,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 54,
    "all_scales_index": 410
  },
  {
    "key": "2_3_1_3_1_1_1",
    "scaleNumber": 442,
    "scale": [
      2,
      3,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 54,
    "all_scales_index": 754
  },
  {
    "key": "3_1_3_1_1_1_2",
    "scaleNumber": 443,
    "scale": [
      3,
      1,
      3,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 54,
    "all_scales_index": 847
  },
  {
    "key": "1_3_1_1_1_2_3",
    "scaleNumber": 444,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 54,
    "all_scales_index": 433
  },
  {
    "key": "3_1_1_1_2_3_1",
    "scaleNumber": 445,
    "scale": [
      3,
      1,
      1,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 54,
    "all_scales_index": 797
  },
  {
    "key": "1_1_1_2_3_2_2",
    "scaleNumber": 446,
    "scale": [
      1,
      1,
      1,
      2,
      3,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 55,
    "all_scales_index": 123
  },
  {
    "key": "1_1_2_3_2_2_1",
    "scaleNumber": 447,
    "scale": [
      1,
      1,
      2,
      3,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 55,
    "all_scales_index": 226
  },
  {
    "key": "1_2_3_2_2_1_1",
    "scaleNumber": 448,
    "scale": [
      1,
      2,
      3,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 55,
    "all_scales_index": 416
  },
  {
    "key": "2_3_2_2_1_1_1",
    "scaleNumber": 449,
    "scale": [
      2,
      3,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 55,
    "all_scales_index": 765
  },
  {
    "key": "3_2_2_1_1_1_2",
    "scaleNumber": 450,
    "scale": [
      3,
      2,
      2,
      1,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 55,
    "all_scales_index": 884
  },
  {
    "key": "2_2_1_1_1_2_3",
    "scaleNumber": 451,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 55,
    "all_scales_index": 663
  },
  {
    "key": "2_1_1_1_2_3_2",
    "scaleNumber": 452,
    "scale": [
      2,
      1,
      1,
      1,
      2,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 55,
    "all_scales_index": 540
  },
  {
    "key": "1_1_1_3_1_1_1_3",
    "scaleNumber": 453,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      1,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 56,
    "all_scales_index": 128
  },
  {
    "key": "1_1_3_1_1_1_3_1",
    "scaleNumber": 454,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 56,
    "all_scales_index": 236
  },
  {
    "key": "1_3_1_1_1_3_1_1",
    "scaleNumber": 455,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 56,
    "all_scales_index": 434
  },
  {
    "key": "3_1_1_1_3_1_1_1",
    "scaleNumber": 456,
    "scale": [
      3,
      1,
      1,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 56,
    "all_scales_index": 798
  },
  {
    "key": "1_1_1_3_1_1_2_2",
    "scaleNumber": 457,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 57,
    "all_scales_index": 130
  },
  {
    "key": "1_1_3_1_1_2_2_1",
    "scaleNumber": 458,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 57,
    "all_scales_index": 239
  },
  {
    "key": "1_3_1_1_2_2_1_1",
    "scaleNumber": 459,
    "scale": [
      1,
      3,
      1,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 57,
    "all_scales_index": 440
  },
  {
    "key": "3_1_1_2_2_1_1_1",
    "scaleNumber": 460,
    "scale": [
      3,
      1,
      1,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 57,
    "all_scales_index": 809
  },
  {
    "key": "1_1_2_2_1_1_1_3",
    "scaleNumber": 461,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 57,
    "all_scales_index": 196
  },
  {
    "key": "1_2_2_1_1_1_3_1",
    "scaleNumber": 462,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 57,
    "all_scales_index": 361
  },
  {
    "key": "2_2_1_1_1_3_1_1",
    "scaleNumber": 463,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 57,
    "all_scales_index": 664
  },
  {
    "key": "2_1_1_1_3_1_1_2",
    "scaleNumber": 464,
    "scale": [
      2,
      1,
      1,
      1,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 57,
    "all_scales_index": 542
  },
  {
    "key": "1_1_1_3_1_2_1_2",
    "scaleNumber": 465,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 58,
    "all_scales_index": 133
  },
  {
    "key": "1_1_3_1_2_1_2_1",
    "scaleNumber": 466,
    "scale": [
      1,
      1,
      3,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 58,
    "all_scales_index": 245
  },
  {
    "key": "1_3_1_2_1_2_1_1",
    "scaleNumber": 467,
    "scale": [
      1,
      3,
      1,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 58,
    "all_scales_index": 451
  },
  {
    "key": "3_1_2_1_2_1_1_1",
    "scaleNumber": 468,
    "scale": [
      3,
      1,
      2,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 58,
    "all_scales_index": 829
  },
  {
    "key": "1_2_1_2_1_1_1_3",
    "scaleNumber": 469,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 58,
    "all_scales_index": 321
  },
  {
    "key": "2_1_2_1_1_1_3_1",
    "scaleNumber": 470,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 58,
    "all_scales_index": 591
  },
  {
    "key": "1_2_1_1_1_3_1_2",
    "scaleNumber": 471,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 58,
    "all_scales_index": 295
  },
  {
    "key": "2_1_1_1_3_1_2_1",
    "scaleNumber": 472,
    "scale": [
      2,
      1,
      1,
      1,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 58,
    "all_scales_index": 543
  },
  {
    "key": "1_1_1_3_1_2_3",
    "scaleNumber": 473,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 59,
    "all_scales_index": 135
  },
  {
    "key": "1_1_3_1_2_3_1",
    "scaleNumber": 474,
    "scale": [
      1,
      1,
      3,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 59,
    "all_scales_index": 249
  },
  {
    "key": "1_3_1_2_3_1_1",
    "scaleNumber": 475,
    "scale": [
      1,
      3,
      1,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 59,
    "all_scales_index": 458
  },
  {
    "key": "3_1_2_3_1_1_1",
    "scaleNumber": 476,
    "scale": [
      3,
      1,
      2,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 59,
    "all_scales_index": 842
  },
  {
    "key": "1_2_3_1_1_1_3",
    "scaleNumber": 477,
    "scale": [
      1,
      2,
      3,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 59,
    "all_scales_index": 402
  },
  {
    "key": "2_3_1_1_1_3_1",
    "scaleNumber": 478,
    "scale": [
      2,
      3,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 59,
    "all_scales_index": 740
  },
  {
    "key": "3_1_1_1_3_1_2",
    "scaleNumber": 479,
    "scale": [
      3,
      1,
      1,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 59,
    "all_scales_index": 799
  },
  {
    "key": "1_1_1_3_1_3_2",
    "scaleNumber": 480,
    "scale": [
      1,
      1,
      1,
      3,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 60,
    "all_scales_index": 137
  },
  {
    "key": "1_1_3_1_3_2_1",
    "scaleNumber": 481,
    "scale": [
      1,
      1,
      3,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 60,
    "all_scales_index": 252
  },
  {
    "key": "1_3_1_3_2_1_1",
    "scaleNumber": 482,
    "scale": [
      1,
      3,
      1,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 60,
    "all_scales_index": 464
  },
  {
    "key": "3_1_3_2_1_1_1",
    "scaleNumber": 483,
    "scale": [
      3,
      1,
      3,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 60,
    "all_scales_index": 853
  },
  {
    "key": "1_3_2_1_1_1_3",
    "scaleNumber": 484,
    "scale": [
      1,
      3,
      2,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 60,
    "all_scales_index": 470
  },
  {
    "key": "3_2_1_1_1_3_1",
    "scaleNumber": 485,
    "scale": [
      3,
      2,
      1,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 60,
    "all_scales_index": 865
  },
  {
    "key": "2_1_1_1_3_1_3",
    "scaleNumber": 486,
    "scale": [
      2,
      1,
      1,
      1,
      3,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 60,
    "all_scales_index": 544
  },
  {
    "key": "1_1_1_3_2_1_1_2",
    "scaleNumber": 487,
    "scale": [
      1,
      1,
      1,
      3,
      2,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 61,
    "all_scales_index": 139
  },
  {
    "key": "1_1_3_2_1_1_2_1",
    "scaleNumber": 488,
    "scale": [
      1,
      1,
      3,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 61,
    "all_scales_index": 256
  },
  {
    "key": "1_3_2_1_1_2_1_1",
    "scaleNumber": 489,
    "scale": [
      1,
      3,
      2,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 61,
    "all_scales_index": 471
  },
  {
    "key": "3_2_1_1_2_1_1_1",
    "scaleNumber": 490,
    "scale": [
      3,
      2,
      1,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 61,
    "all_scales_index": 866
  },
  {
    "key": "2_1_1_2_1_1_1_3",
    "scaleNumber": 491,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 61,
    "all_scales_index": 551
  },
  {
    "key": "1_1_2_1_1_1_3_2",
    "scaleNumber": 492,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 61,
    "all_scales_index": 161
  },
  {
    "key": "1_2_1_1_1_3_2_1",
    "scaleNumber": 493,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 61,
    "all_scales_index": 296
  },
  {
    "key": "2_1_1_1_3_2_1_1",
    "scaleNumber": 494,
    "scale": [
      2,
      1,
      1,
      1,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 61,
    "all_scales_index": 545
  },
  {
    "key": "1_1_1_3_2_1_3",
    "scaleNumber": 495,
    "scale": [
      1,
      1,
      1,
      3,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 62,
    "all_scales_index": 141
  },
  {
    "key": "1_1_3_2_1_3_1",
    "scaleNumber": 496,
    "scale": [
      1,
      1,
      3,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 62,
    "all_scales_index": 260
  },
  {
    "key": "1_3_2_1_3_1_1",
    "scaleNumber": 497,
    "scale": [
      1,
      3,
      2,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 62,
    "all_scales_index": 478
  },
  {
    "key": "3_2_1_3_1_1_1",
    "scaleNumber": 498,
    "scale": [
      3,
      2,
      1,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 62,
    "all_scales_index": 879
  },
  {
    "key": "2_1_3_1_1_1_3",
    "scaleNumber": 499,
    "scale": [
      2,
      1,
      3,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 62,
    "all_scales_index": 632
  },
  {
    "key": "1_3_1_1_1_3_2",
    "scaleNumber": 500,
    "scale": [
      1,
      3,
      1,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 62,
    "all_scales_index": 435
  },
  {
    "key": "3_1_1_1_3_2_1",
    "scaleNumber": 501,
    "scale": [
      3,
      1,
      1,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 62,
    "all_scales_index": 800
  },
  {
    "key": "1_1_1_3_2_2_2",
    "scaleNumber": 502,
    "scale": [
      1,
      1,
      1,
      3,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 63,
    "all_scales_index": 143
  },
  {
    "key": "1_1_3_2_2_2_1",
    "scaleNumber": 503,
    "scale": [
      1,
      1,
      3,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 63,
    "all_scales_index": 263
  },
  {
    "key": "1_3_2_2_2_1_1",
    "scaleNumber": 504,
    "scale": [
      1,
      3,
      2,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 63,
    "all_scales_index": 484
  },
  {
    "key": "3_2_2_2_1_1_1",
    "scaleNumber": 505,
    "scale": [
      3,
      2,
      2,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 63,
    "all_scales_index": 890
  },
  {
    "key": "2_2_2_1_1_1_3",
    "scaleNumber": 506,
    "scale": [
      2,
      2,
      2,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 63,
    "all_scales_index": 700
  },
  {
    "key": "2_2_1_1_1_3_2",
    "scaleNumber": 507,
    "scale": [
      2,
      2,
      1,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 63,
    "all_scales_index": 665
  },
  {
    "key": "2_1_1_1_3_2_2",
    "scaleNumber": 508,
    "scale": [
      2,
      1,
      1,
      1,
      3,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 63,
    "all_scales_index": 546
  },
  {
    "key": "1_1_1_3_3_1_2",
    "scaleNumber": 509,
    "scale": [
      1,
      1,
      1,
      3,
      3,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 64,
    "all_scales_index": 146
  },
  {
    "key": "1_1_3_3_1_2_1",
    "scaleNumber": 510,
    "scale": [
      1,
      1,
      3,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 64,
    "all_scales_index": 269
  },
  {
    "key": "1_3_3_1_2_1_1",
    "scaleNumber": 511,
    "scale": [
      1,
      3,
      3,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 64,
    "all_scales_index": 495
  },
  {
    "key": "3_3_1_2_1_1_1",
    "scaleNumber": 512,
    "scale": [
      3,
      3,
      1,
      2,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 64,
    "all_scales_index": 910
  },
  {
    "key": "3_1_2_1_1_1_3",
    "scaleNumber": 513,
    "scale": [
      3,
      1,
      2,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 64,
    "all_scales_index": 825
  },
  {
    "key": "1_2_1_1_1_3_3",
    "scaleNumber": 514,
    "scale": [
      1,
      2,
      1,
      1,
      1,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 64,
    "all_scales_index": 297
  },
  {
    "key": "2_1_1_1_3_3_1",
    "scaleNumber": 515,
    "scale": [
      2,
      1,
      1,
      1,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 64,
    "all_scales_index": 547
  },
  {
    "key": "1_1_1_3_3_3",
    "scaleNumber": 516,
    "scale": [
      1,
      1,
      1,
      3,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 65,
    "all_scales_index": 148
  },
  {
    "key": "1_1_3_3_3_1",
    "scaleNumber": 517,
    "scale": [
      1,
      1,
      3,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 65,
    "all_scales_index": 273
  },
  {
    "key": "1_3_3_3_1_1",
    "scaleNumber": 518,
    "scale": [
      1,
      3,
      3,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 65,
    "all_scales_index": 502
  },
  {
    "key": "3_3_3_1_1_1",
    "scaleNumber": 519,
    "scale": [
      3,
      3,
      3,
      1,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 65,
    "all_scales_index": 923
  },
  {
    "key": "3_3_1_1_1_3",
    "scaleNumber": 520,
    "scale": [
      3,
      3,
      1,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 65,
    "all_scales_index": 906
  },
  {
    "key": "3_1_1_1_3_3",
    "scaleNumber": 521,
    "scale": [
      3,
      1,
      1,
      1,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 65,
    "all_scales_index": 801
  },
  {
    "key": "1_1_2_1_1_2_1_1_2",
    "scaleNumber": 522,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 66,
    "all_scales_index": 163
  },
  {
    "key": "1_2_1_1_2_1_1_2_1",
    "scaleNumber": 523,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 66,
    "all_scales_index": 300
  },
  {
    "key": "2_1_1_2_1_1_2_1_1",
    "scaleNumber": 524,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 66,
    "all_scales_index": 552
  },
  {
    "key": "1_1_2_1_1_2_1_3",
    "scaleNumber": 525,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 67,
    "all_scales_index": 165
  },
  {
    "key": "1_2_1_1_2_1_3_1",
    "scaleNumber": 526,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 67,
    "all_scales_index": 304
  },
  {
    "key": "2_1_1_2_1_3_1_1",
    "scaleNumber": 527,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 67,
    "all_scales_index": 559
  },
  {
    "key": "1_1_2_1_3_1_1_2",
    "scaleNumber": 528,
    "scale": [
      1,
      1,
      2,
      1,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 67,
    "all_scales_index": 187
  },
  {
    "key": "1_2_1_3_1_1_2_1",
    "scaleNumber": 529,
    "scale": [
      1,
      2,
      1,
      3,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 67,
    "all_scales_index": 344
  },
  {
    "key": "2_1_3_1_1_2_1_1",
    "scaleNumber": 530,
    "scale": [
      2,
      1,
      3,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 67,
    "all_scales_index": 633
  },
  {
    "key": "1_3_1_1_2_1_1_2",
    "scaleNumber": 531,
    "scale": [
      1,
      3,
      1,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 67,
    "all_scales_index": 437
  },
  {
    "key": "3_1_1_2_1_1_2_1",
    "scaleNumber": 532,
    "scale": [
      3,
      1,
      1,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 67,
    "all_scales_index": 804
  },
  {
    "key": "1_1_2_1_1_2_2_2",
    "scaleNumber": 533,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 68,
    "all_scales_index": 167
  },
  {
    "key": "1_2_1_1_2_2_2_1",
    "scaleNumber": 534,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 68,
    "all_scales_index": 307
  },
  {
    "key": "2_1_1_2_2_2_1_1",
    "scaleNumber": 535,
    "scale": [
      2,
      1,
      1,
      2,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 68,
    "all_scales_index": 565
  },
  {
    "key": "1_1_2_2_2_1_1_2",
    "scaleNumber": 536,
    "scale": [
      1,
      1,
      2,
      2,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 68,
    "all_scales_index": 207
  },
  {
    "key": "1_2_2_2_1_1_2_1",
    "scaleNumber": 537,
    "scale": [
      1,
      2,
      2,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 68,
    "all_scales_index": 381
  },
  {
    "key": "2_2_2_1_1_2_1_1",
    "scaleNumber": 538,
    "scale": [
      2,
      2,
      2,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 68,
    "all_scales_index": 701
  },
  {
    "key": "2_2_1_1_2_1_1_2",
    "scaleNumber": 539,
    "scale": [
      2,
      2,
      1,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 68,
    "all_scales_index": 667
  },
  {
    "key": "2_1_1_2_1_1_2_2",
    "scaleNumber": 540,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 68,
    "all_scales_index": 553
  },
  {
    "key": "1_1_2_1_1_3_1_2",
    "scaleNumber": 541,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      3,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 69,
    "all_scales_index": 170
  },
  {
    "key": "1_2_1_1_3_1_2_1",
    "scaleNumber": 542,
    "scale": [
      1,
      2,
      1,
      1,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 69,
    "all_scales_index": 313
  },
  {
    "key": "2_1_1_3_1_2_1_1",
    "scaleNumber": 543,
    "scale": [
      2,
      1,
      1,
      3,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 69,
    "all_scales_index": 576
  },
  {
    "key": "1_1_3_1_2_1_1_2",
    "scaleNumber": 544,
    "scale": [
      1,
      1,
      3,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 69,
    "all_scales_index": 244
  },
  {
    "key": "1_3_1_2_1_1_2_1",
    "scaleNumber": 545,
    "scale": [
      1,
      3,
      1,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 69,
    "all_scales_index": 449
  },
  {
    "key": "3_1_2_1_1_2_1_1",
    "scaleNumber": 546,
    "scale": [
      3,
      1,
      2,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 69,
    "all_scales_index": 826
  },
  {
    "key": "1_2_1_1_2_1_1_3",
    "scaleNumber": 547,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 69,
    "all_scales_index": 301
  },
  {
    "key": "2_1_1_2_1_1_3_1",
    "scaleNumber": 548,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 69,
    "all_scales_index": 554
  },
  {
    "key": "1_1_2_1_1_3_3",
    "scaleNumber": 549,
    "scale": [
      1,
      1,
      2,
      1,
      1,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 70,
    "all_scales_index": 172
  },
  {
    "key": "1_2_1_1_3_3_1",
    "scaleNumber": 550,
    "scale": [
      1,
      2,
      1,
      1,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 70,
    "all_scales_index": 317
  },
  {
    "key": "2_1_1_3_3_1_1",
    "scaleNumber": 551,
    "scale": [
      2,
      1,
      1,
      3,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 70,
    "all_scales_index": 583
  },
  {
    "key": "1_1_3_3_1_1_2",
    "scaleNumber": 552,
    "scale": [
      1,
      1,
      3,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 70,
    "all_scales_index": 268
  },
  {
    "key": "1_3_3_1_1_2_1",
    "scaleNumber": 553,
    "scale": [
      1,
      3,
      3,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 70,
    "all_scales_index": 493
  },
  {
    "key": "3_3_1_1_2_1_1",
    "scaleNumber": 554,
    "scale": [
      3,
      3,
      1,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 70,
    "all_scales_index": 907
  },
  {
    "key": "3_1_1_2_1_1_3",
    "scaleNumber": 555,
    "scale": [
      3,
      1,
      1,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 70,
    "all_scales_index": 805
  },
  {
    "key": "1_1_2_1_2_1_1_3",
    "scaleNumber": 556,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      1,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 71,
    "all_scales_index": 176
  },
  {
    "key": "1_2_1_2_1_1_3_1",
    "scaleNumber": 557,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 71,
    "all_scales_index": 324
  },
  {
    "key": "2_1_2_1_1_3_1_1",
    "scaleNumber": 558,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 71,
    "all_scales_index": 596
  },
  {
    "key": "1_2_1_1_3_1_1_2",
    "scaleNumber": 559,
    "scale": [
      1,
      2,
      1,
      1,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 71,
    "all_scales_index": 312
  },
  {
    "key": "2_1_1_3_1_1_2_1",
    "scaleNumber": 560,
    "scale": [
      2,
      1,
      1,
      3,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 71,
    "all_scales_index": 574
  },
  {
    "key": "1_1_3_1_1_2_1_2",
    "scaleNumber": 561,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 71,
    "all_scales_index": 238
  },
  {
    "key": "1_3_1_1_2_1_2_1",
    "scaleNumber": 562,
    "scale": [
      1,
      3,
      1,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 71,
    "all_scales_index": 438
  },
  {
    "key": "3_1_1_2_1_2_1_1",
    "scaleNumber": 563,
    "scale": [
      3,
      1,
      1,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 71,
    "all_scales_index": 806
  },
  {
    "key": "1_1_2_1_2_1_2_2",
    "scaleNumber": 564,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 72,
    "all_scales_index": 178
  },
  {
    "key": "1_2_1_2_1_2_2_1",
    "scaleNumber": 565,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 72,
    "all_scales_index": 327
  },
  {
    "key": "2_1_2_1_2_2_1_1",
    "scaleNumber": 566,
    "scale": [
      2,
      1,
      2,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 72,
    "all_scales_index": 602
  },
  {
    "key": "1_2_1_2_2_1_1_2",
    "scaleNumber": 567,
    "scale": [
      1,
      2,
      1,
      2,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 72,
    "all_scales_index": 332
  },
  {
    "key": "2_1_2_2_1_1_2_1",
    "scaleNumber": 568,
    "scale": [
      2,
      1,
      2,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 72,
    "all_scales_index": 611
  },
  {
    "key": "1_2_2_1_1_2_1_2",
    "scaleNumber": 569,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 72,
    "all_scales_index": 363
  },
  {
    "key": "2_2_1_1_2_1_2_1",
    "scaleNumber": 570,
    "scale": [
      2,
      2,
      1,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 72,
    "all_scales_index": 668
  },
  {
    "key": "2_1_1_2_1_2_1_2",
    "scaleNumber": 571,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 72,
    "all_scales_index": 556
  },
  {
    "key": "1_1_2_1_2_2_1_2",
    "scaleNumber": 572,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 73,
    "all_scales_index": 181
  },
  {
    "key": "1_2_1_2_2_1_2_1",
    "scaleNumber": 573,
    "scale": [
      1,
      2,
      1,
      2,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 73,
    "all_scales_index": 333
  },
  {
    "key": "2_1_2_2_1_2_1_1",
    "scaleNumber": 574,
    "scale": [
      2,
      1,
      2,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 73,
    "all_scales_index": 613
  },
  {
    "key": "1_2_2_1_2_1_1_2",
    "scaleNumber": 575,
    "scale": [
      1,
      2,
      2,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 73,
    "all_scales_index": 369
  },
  {
    "key": "2_2_1_2_1_1_2_1",
    "scaleNumber": 576,
    "scale": [
      2,
      2,
      1,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 73,
    "all_scales_index": 679
  },
  {
    "key": "2_1_2_1_1_2_1_2",
    "scaleNumber": 577,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 73,
    "all_scales_index": 593
  },
  {
    "key": "1_2_1_1_2_1_2_2",
    "scaleNumber": 578,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 73,
    "all_scales_index": 303
  },
  {
    "key": "2_1_1_2_1_2_2_1",
    "scaleNumber": 579,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 73,
    "all_scales_index": 557
  },
  {
    "key": "1_1_2_1_2_2_3",
    "scaleNumber": 580,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 74,
    "all_scales_index": 183
  },
  {
    "key": "1_2_1_2_2_3_1",
    "scaleNumber": 581,
    "scale": [
      1,
      2,
      1,
      2,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 74,
    "all_scales_index": 337
  },
  {
    "key": "2_1_2_2_3_1_1",
    "scaleNumber": 582,
    "scale": [
      2,
      1,
      2,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 74,
    "all_scales_index": 620
  },
  {
    "key": "1_2_2_3_1_1_2",
    "scaleNumber": 583,
    "scale": [
      1,
      2,
      2,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 74,
    "all_scales_index": 393
  },
  {
    "key": "2_2_3_1_1_2_1",
    "scaleNumber": 584,
    "scale": [
      2,
      2,
      3,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 74,
    "all_scales_index": 723
  },
  {
    "key": "2_3_1_1_2_1_2",
    "scaleNumber": 585,
    "scale": [
      2,
      3,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 74,
    "all_scales_index": 742
  },
  {
    "key": "3_1_1_2_1_2_2",
    "scaleNumber": 586,
    "scale": [
      3,
      1,
      1,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 74,
    "all_scales_index": 807
  },
  {
    "key": "1_1_2_1_2_3_2",
    "scaleNumber": 587,
    "scale": [
      1,
      1,
      2,
      1,
      2,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 75,
    "all_scales_index": 185
  },
  {
    "key": "1_2_1_2_3_2_1",
    "scaleNumber": 588,
    "scale": [
      1,
      2,
      1,
      2,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 75,
    "all_scales_index": 340
  },
  {
    "key": "2_1_2_3_2_1_1",
    "scaleNumber": 589,
    "scale": [
      2,
      1,
      2,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 75,
    "all_scales_index": 626
  },
  {
    "key": "1_2_3_2_1_1_2",
    "scaleNumber": 590,
    "scale": [
      1,
      2,
      3,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 75,
    "all_scales_index": 413
  },
  {
    "key": "2_3_2_1_1_2_1",
    "scaleNumber": 591,
    "scale": [
      2,
      3,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 75,
    "all_scales_index": 760
  },
  {
    "key": "3_2_1_1_2_1_2",
    "scaleNumber": 592,
    "scale": [
      3,
      2,
      1,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 75,
    "all_scales_index": 867
  },
  {
    "key": "2_1_1_2_1_2_3",
    "scaleNumber": 593,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 75,
    "all_scales_index": 558
  },
  {
    "key": "1_1_2_1_3_1_3",
    "scaleNumber": 594,
    "scale": [
      1,
      1,
      2,
      1,
      3,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 76,
    "all_scales_index": 189
  },
  {
    "key": "1_2_1_3_1_3_1",
    "scaleNumber": 595,
    "scale": [
      1,
      2,
      1,
      3,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 76,
    "all_scales_index": 348
  },
  {
    "key": "2_1_3_1_3_1_1",
    "scaleNumber": 596,
    "scale": [
      2,
      1,
      3,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 76,
    "all_scales_index": 640
  },
  {
    "key": "1_3_1_3_1_1_2",
    "scaleNumber": 597,
    "scale": [
      1,
      3,
      1,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 76,
    "all_scales_index": 461
  },
  {
    "key": "3_1_3_1_1_2_1",
    "scaleNumber": 598,
    "scale": [
      3,
      1,
      3,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 76,
    "all_scales_index": 848
  },
  {
    "key": "1_3_1_1_2_1_3",
    "scaleNumber": 599,
    "scale": [
      1,
      3,
      1,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 76,
    "all_scales_index": 439
  },
  {
    "key": "3_1_1_2_1_3_1",
    "scaleNumber": 600,
    "scale": [
      3,
      1,
      1,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 76,
    "all_scales_index": 808
  },
  {
    "key": "1_1_2_1_3_2_2",
    "scaleNumber": 601,
    "scale": [
      1,
      1,
      2,
      1,
      3,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 77,
    "all_scales_index": 191
  },
  {
    "key": "1_2_1_3_2_2_1",
    "scaleNumber": 602,
    "scale": [
      1,
      2,
      1,
      3,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 77,
    "all_scales_index": 351
  },
  {
    "key": "2_1_3_2_2_1_1",
    "scaleNumber": 603,
    "scale": [
      2,
      1,
      3,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 77,
    "all_scales_index": 646
  },
  {
    "key": "1_3_2_2_1_1_2",
    "scaleNumber": 604,
    "scale": [
      1,
      3,
      2,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 77,
    "all_scales_index": 481
  },
  {
    "key": "3_2_2_1_1_2_1",
    "scaleNumber": 605,
    "scale": [
      3,
      2,
      2,
      1,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 77,
    "all_scales_index": 885
  },
  {
    "key": "2_2_1_1_2_1_3",
    "scaleNumber": 606,
    "scale": [
      2,
      2,
      1,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 77,
    "all_scales_index": 669
  },
  {
    "key": "2_1_1_2_1_3_2",
    "scaleNumber": 607,
    "scale": [
      2,
      1,
      1,
      2,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 77,
    "all_scales_index": 560
  },
  {
    "key": "1_1_2_2_1_1_2_2",
    "scaleNumber": 608,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 78,
    "all_scales_index": 198
  },
  {
    "key": "1_2_2_1_1_2_2_1",
    "scaleNumber": 609,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 78,
    "all_scales_index": 364
  },
  {
    "key": "2_2_1_1_2_2_1_1",
    "scaleNumber": 610,
    "scale": [
      2,
      2,
      1,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 78,
    "all_scales_index": 670
  },
  {
    "key": "2_1_1_2_2_1_1_2",
    "scaleNumber": 611,
    "scale": [
      2,
      1,
      1,
      2,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 78,
    "all_scales_index": 562
  },
  {
    "key": "1_1_2_2_1_2_1_2",
    "scaleNumber": 612,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 79,
    "all_scales_index": 201
  },
  {
    "key": "1_2_2_1_2_1_2_1",
    "scaleNumber": 613,
    "scale": [
      1,
      2,
      2,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 79,
    "all_scales_index": 370
  },
  {
    "key": "2_2_1_2_1_2_1_1",
    "scaleNumber": 614,
    "scale": [
      2,
      2,
      1,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 79,
    "all_scales_index": 681
  },
  {
    "key": "2_1_2_1_2_1_1_2",
    "scaleNumber": 615,
    "scale": [
      2,
      1,
      2,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 79,
    "all_scales_index": 599
  },
  {
    "key": "1_2_1_2_1_1_2_2",
    "scaleNumber": 616,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 79,
    "all_scales_index": 323
  },
  {
    "key": "2_1_2_1_1_2_2_1",
    "scaleNumber": 617,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 79,
    "all_scales_index": 594
  },
  {
    "key": "1_2_1_1_2_2_1_2",
    "scaleNumber": 618,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 79,
    "all_scales_index": 306
  },
  {
    "key": "2_1_1_2_2_1_2_1",
    "scaleNumber": 619,
    "scale": [
      2,
      1,
      1,
      2,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 8,
    "superscale_index": 79,
    "all_scales_index": 563
  },
  {
    "key": "1_1_2_2_1_2_3",
    "scaleNumber": 620,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 80,
    "all_scales_index": 203
  },
  {
    "key": "1_2_2_1_2_3_1",
    "scaleNumber": 621,
    "scale": [
      1,
      2,
      2,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 80,
    "all_scales_index": 374
  },
  {
    "key": "2_2_1_2_3_1_1",
    "scaleNumber": 622,
    "scale": [
      2,
      2,
      1,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 80,
    "all_scales_index": 688
  },
  {
    "key": "2_1_2_3_1_1_2",
    "scaleNumber": 623,
    "scale": [
      2,
      1,
      2,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 80,
    "all_scales_index": 623
  },
  {
    "key": "1_2_3_1_1_2_2",
    "scaleNumber": 624,
    "scale": [
      1,
      2,
      3,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 80,
    "all_scales_index": 404
  },
  {
    "key": "2_3_1_1_2_2_1",
    "scaleNumber": 625,
    "scale": [
      2,
      3,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 80,
    "all_scales_index": 743
  },
  {
    "key": "3_1_1_2_2_1_2",
    "scaleNumber": 626,
    "scale": [
      3,
      1,
      1,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 80,
    "all_scales_index": 810
  },
  {
    "key": "1_1_2_2_1_3_2",
    "scaleNumber": 627,
    "scale": [
      1,
      1,
      2,
      2,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 81,
    "all_scales_index": 205
  },
  {
    "key": "1_2_2_1_3_2_1",
    "scaleNumber": 628,
    "scale": [
      1,
      2,
      2,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 81,
    "all_scales_index": 377
  },
  {
    "key": "2_2_1_3_2_1_1",
    "scaleNumber": 629,
    "scale": [
      2,
      2,
      1,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 81,
    "all_scales_index": 694
  },
  {
    "key": "2_1_3_2_1_1_2",
    "scaleNumber": 630,
    "scale": [
      2,
      1,
      3,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 81,
    "all_scales_index": 643
  },
  {
    "key": "1_3_2_1_1_2_2",
    "scaleNumber": 631,
    "scale": [
      1,
      3,
      2,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 81,
    "all_scales_index": 472
  },
  {
    "key": "3_2_1_1_2_2_1",
    "scaleNumber": 632,
    "scale": [
      3,
      2,
      1,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 81,
    "all_scales_index": 868
  },
  {
    "key": "2_1_1_2_2_1_3",
    "scaleNumber": 633,
    "scale": [
      2,
      1,
      1,
      2,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 81,
    "all_scales_index": 564
  },
  {
    "key": "1_1_2_2_2_1_3",
    "scaleNumber": 634,
    "scale": [
      1,
      1,
      2,
      2,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 82,
    "all_scales_index": 209
  },
  {
    "key": "1_2_2_2_1_3_1",
    "scaleNumber": 635,
    "scale": [
      1,
      2,
      2,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 82,
    "all_scales_index": 385
  },
  {
    "key": "2_2_2_1_3_1_1",
    "scaleNumber": 636,
    "scale": [
      2,
      2,
      2,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 82,
    "all_scales_index": 708
  },
  {
    "key": "2_2_1_3_1_1_2",
    "scaleNumber": 637,
    "scale": [
      2,
      2,
      1,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 82,
    "all_scales_index": 691
  },
  {
    "key": "2_1_3_1_1_2_2",
    "scaleNumber": 638,
    "scale": [
      2,
      1,
      3,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 82,
    "all_scales_index": 634
  },
  {
    "key": "1_3_1_1_2_2_2",
    "scaleNumber": 639,
    "scale": [
      1,
      3,
      1,
      1,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 82,
    "all_scales_index": 441
  },
  {
    "key": "3_1_1_2_2_2_1",
    "scaleNumber": 640,
    "scale": [
      3,
      1,
      1,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 82,
    "all_scales_index": 811
  },
  {
    "key": "1_1_2_2_2_2_2",
    "scaleNumber": 641,
    "scale": [
      1,
      1,
      2,
      2,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 83,
    "all_scales_index": 211
  },
  {
    "key": "1_2_2_2_2_2_1",
    "scaleNumber": 642,
    "scale": [
      1,
      2,
      2,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 83,
    "all_scales_index": 388
  },
  {
    "key": "2_2_2_2_2_1_1",
    "scaleNumber": 643,
    "scale": [
      2,
      2,
      2,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 83,
    "all_scales_index": 714
  },
  {
    "key": "2_2_2_2_1_1_2",
    "scaleNumber": 644,
    "scale": [
      2,
      2,
      2,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 83,
    "all_scales_index": 711
  },
  {
    "key": "2_2_2_1_1_2_2",
    "scaleNumber": 645,
    "scale": [
      2,
      2,
      2,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 83,
    "all_scales_index": 702
  },
  {
    "key": "2_2_1_1_2_2_2",
    "scaleNumber": 646,
    "scale": [
      2,
      2,
      1,
      1,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 83,
    "all_scales_index": 671
  },
  {
    "key": "2_1_1_2_2_2_2",
    "scaleNumber": 647,
    "scale": [
      2,
      1,
      1,
      2,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 83,
    "all_scales_index": 566
  },
  {
    "key": "1_1_2_2_3_1_2",
    "scaleNumber": 648,
    "scale": [
      1,
      1,
      2,
      2,
      3,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 84,
    "all_scales_index": 214
  },
  {
    "key": "1_2_2_3_1_2_1",
    "scaleNumber": 649,
    "scale": [
      1,
      2,
      2,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 84,
    "all_scales_index": 394
  },
  {
    "key": "2_2_3_1_2_1_1",
    "scaleNumber": 650,
    "scale": [
      2,
      2,
      3,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 84,
    "all_scales_index": 725
  },
  {
    "key": "2_3_1_2_1_1_2",
    "scaleNumber": 651,
    "scale": [
      2,
      3,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 84,
    "all_scales_index": 748
  },
  {
    "key": "3_1_2_1_1_2_2",
    "scaleNumber": 652,
    "scale": [
      3,
      1,
      2,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 84,
    "all_scales_index": 827
  },
  {
    "key": "1_2_1_1_2_2_3",
    "scaleNumber": 653,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 84,
    "all_scales_index": 308
  },
  {
    "key": "2_1_1_2_2_3_1",
    "scaleNumber": 654,
    "scale": [
      2,
      1,
      1,
      2,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 84,
    "all_scales_index": 567
  },
  {
    "key": "1_1_2_2_3_3",
    "scaleNumber": 655,
    "scale": [
      1,
      1,
      2,
      2,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 85,
    "all_scales_index": 216
  },
  {
    "key": "1_2_2_3_3_1",
    "scaleNumber": 656,
    "scale": [
      1,
      2,
      2,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 85,
    "all_scales_index": 398
  },
  {
    "key": "2_2_3_3_1_1",
    "scaleNumber": 657,
    "scale": [
      2,
      2,
      3,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 85,
    "all_scales_index": 732
  },
  {
    "key": "2_3_3_1_1_2",
    "scaleNumber": 658,
    "scale": [
      2,
      3,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 85,
    "all_scales_index": 772
  },
  {
    "key": "3_3_1_1_2_2",
    "scaleNumber": 659,
    "scale": [
      3,
      3,
      1,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 85,
    "all_scales_index": 908
  },
  {
    "key": "3_1_1_2_2_3",
    "scaleNumber": 660,
    "scale": [
      3,
      1,
      1,
      2,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 85,
    "all_scales_index": 812
  },
  {
    "key": "1_1_2_3_1_1_3",
    "scaleNumber": 661,
    "scale": [
      1,
      1,
      2,
      3,
      1,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 86,
    "all_scales_index": 220
  },
  {
    "key": "1_2_3_1_1_3_1",
    "scaleNumber": 662,
    "scale": [
      1,
      2,
      3,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 86,
    "all_scales_index": 405
  },
  {
    "key": "2_3_1_1_3_1_1",
    "scaleNumber": 663,
    "scale": [
      2,
      3,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 86,
    "all_scales_index": 745
  },
  {
    "key": "3_1_1_3_1_1_2",
    "scaleNumber": 664,
    "scale": [
      3,
      1,
      1,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 86,
    "all_scales_index": 816
  },
  {
    "key": "1_1_3_1_1_2_3",
    "scaleNumber": 665,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 86,
    "all_scales_index": 240
  },
  {
    "key": "1_3_1_1_2_3_1",
    "scaleNumber": 666,
    "scale": [
      1,
      3,
      1,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 86,
    "all_scales_index": 442
  },
  {
    "key": "3_1_1_2_3_1_1",
    "scaleNumber": 667,
    "scale": [
      3,
      1,
      1,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 86,
    "all_scales_index": 813
  },
  {
    "key": "1_1_2_3_1_2_2",
    "scaleNumber": 668,
    "scale": [
      1,
      1,
      2,
      3,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 87,
    "all_scales_index": 222
  },
  {
    "key": "1_2_3_1_2_2_1",
    "scaleNumber": 669,
    "scale": [
      1,
      2,
      3,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 87,
    "all_scales_index": 408
  },
  {
    "key": "2_3_1_2_2_1_1",
    "scaleNumber": 670,
    "scale": [
      2,
      3,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 87,
    "all_scales_index": 751
  },
  {
    "key": "3_1_2_2_1_1_2",
    "scaleNumber": 671,
    "scale": [
      3,
      1,
      2,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 87,
    "all_scales_index": 836
  },
  {
    "key": "1_2_2_1_1_2_3",
    "scaleNumber": 672,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 87,
    "all_scales_index": 365
  },
  {
    "key": "2_2_1_1_2_3_1",
    "scaleNumber": 673,
    "scale": [
      2,
      2,
      1,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 87,
    "all_scales_index": 672
  },
  {
    "key": "2_1_1_2_3_1_2",
    "scaleNumber": 674,
    "scale": [
      2,
      1,
      1,
      2,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 87,
    "all_scales_index": 569
  },
  {
    "key": "1_1_2_3_2_1_2",
    "scaleNumber": 675,
    "scale": [
      1,
      1,
      2,
      3,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 88,
    "all_scales_index": 225
  },
  {
    "key": "1_2_3_2_1_2_1",
    "scaleNumber": 676,
    "scale": [
      1,
      2,
      3,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 88,
    "all_scales_index": 414
  },
  {
    "key": "2_3_2_1_2_1_1",
    "scaleNumber": 677,
    "scale": [
      2,
      3,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 88,
    "all_scales_index": 762
  },
  {
    "key": "3_2_1_2_1_1_2",
    "scaleNumber": 678,
    "scale": [
      3,
      2,
      1,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 88,
    "all_scales_index": 873
  },
  {
    "key": "2_1_2_1_1_2_3",
    "scaleNumber": 679,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 88,
    "all_scales_index": 595
  },
  {
    "key": "1_2_1_1_2_3_2",
    "scaleNumber": 680,
    "scale": [
      1,
      2,
      1,
      1,
      2,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 88,
    "all_scales_index": 310
  },
  {
    "key": "2_1_1_2_3_2_1",
    "scaleNumber": 681,
    "scale": [
      2,
      1,
      1,
      2,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 88,
    "all_scales_index": 570
  },
  {
    "key": "1_1_2_3_2_3",
    "scaleNumber": 682,
    "scale": [
      1,
      1,
      2,
      3,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 89,
    "all_scales_index": 227
  },
  {
    "key": "1_2_3_2_3_1",
    "scaleNumber": 683,
    "scale": [
      1,
      2,
      3,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 89,
    "all_scales_index": 418
  },
  {
    "key": "2_3_2_3_1_1",
    "scaleNumber": 684,
    "scale": [
      2,
      3,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 89,
    "all_scales_index": 769
  },
  {
    "key": "3_2_3_1_1_2",
    "scaleNumber": 685,
    "scale": [
      3,
      2,
      3,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 89,
    "all_scales_index": 897
  },
  {
    "key": "2_3_1_1_2_3",
    "scaleNumber": 686,
    "scale": [
      2,
      3,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 89,
    "all_scales_index": 744
  },
  {
    "key": "3_1_1_2_3_2",
    "scaleNumber": 687,
    "scale": [
      3,
      1,
      1,
      2,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 89,
    "all_scales_index": 814
  },
  {
    "key": "1_1_2_3_3_2",
    "scaleNumber": 688,
    "scale": [
      1,
      1,
      2,
      3,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 90,
    "all_scales_index": 229
  },
  {
    "key": "1_2_3_3_2_1",
    "scaleNumber": 689,
    "scale": [
      1,
      2,
      3,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 90,
    "all_scales_index": 421
  },
  {
    "key": "2_3_3_2_1_1",
    "scaleNumber": 690,
    "scale": [
      2,
      3,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 90,
    "all_scales_index": 775
  },
  {
    "key": "3_3_2_1_1_2",
    "scaleNumber": 691,
    "scale": [
      3,
      3,
      2,
      1,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 90,
    "all_scales_index": 917
  },
  {
    "key": "3_2_1_1_2_3",
    "scaleNumber": 692,
    "scale": [
      3,
      2,
      1,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 90,
    "all_scales_index": 869
  },
  {
    "key": "2_1_1_2_3_3",
    "scaleNumber": 693,
    "scale": [
      2,
      1,
      1,
      2,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 90,
    "all_scales_index": 571
  },
  {
    "key": "1_1_3_1_1_3_2",
    "scaleNumber": 694,
    "scale": [
      1,
      1,
      3,
      1,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 91,
    "all_scales_index": 242
  },
  {
    "key": "1_3_1_1_3_2_1",
    "scaleNumber": 695,
    "scale": [
      1,
      3,
      1,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 91,
    "all_scales_index": 445
  },
  {
    "key": "3_1_1_3_2_1_1",
    "scaleNumber": 696,
    "scale": [
      3,
      1,
      1,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 91,
    "all_scales_index": 819
  },
  {
    "key": "1_1_3_2_1_1_3",
    "scaleNumber": 697,
    "scale": [
      1,
      1,
      3,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 91,
    "all_scales_index": 257
  },
  {
    "key": "1_3_2_1_1_3_1",
    "scaleNumber": 698,
    "scale": [
      1,
      3,
      2,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 91,
    "all_scales_index": 473
  },
  {
    "key": "3_2_1_1_3_1_1",
    "scaleNumber": 699,
    "scale": [
      3,
      2,
      1,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 91,
    "all_scales_index": 870
  },
  {
    "key": "2_1_1_3_1_1_3",
    "scaleNumber": 700,
    "scale": [
      2,
      1,
      1,
      3,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 91,
    "all_scales_index": 575
  },
  {
    "key": "1_1_3_1_2_1_3",
    "scaleNumber": 701,
    "scale": [
      1,
      1,
      3,
      1,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 92,
    "all_scales_index": 246
  },
  {
    "key": "1_3_1_2_1_3_1",
    "scaleNumber": 702,
    "scale": [
      1,
      3,
      1,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 92,
    "all_scales_index": 453
  },
  {
    "key": "3_1_2_1_3_1_1",
    "scaleNumber": 703,
    "scale": [
      3,
      1,
      2,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 92,
    "all_scales_index": 833
  },
  {
    "key": "1_2_1_3_1_1_3",
    "scaleNumber": 704,
    "scale": [
      1,
      2,
      1,
      3,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 92,
    "all_scales_index": 345
  },
  {
    "key": "2_1_3_1_1_3_1",
    "scaleNumber": 705,
    "scale": [
      2,
      1,
      3,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 92,
    "all_scales_index": 635
  },
  {
    "key": "1_3_1_1_3_1_2",
    "scaleNumber": 706,
    "scale": [
      1,
      3,
      1,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 92,
    "all_scales_index": 444
  },
  {
    "key": "3_1_1_3_1_2_1",
    "scaleNumber": 707,
    "scale": [
      3,
      1,
      1,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 92,
    "all_scales_index": 817
  },
  {
    "key": "1_1_3_1_2_2_2",
    "scaleNumber": 708,
    "scale": [
      1,
      1,
      3,
      1,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 93,
    "all_scales_index": 248
  },
  {
    "key": "1_3_1_2_2_2_1",
    "scaleNumber": 709,
    "scale": [
      1,
      3,
      1,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 93,
    "all_scales_index": 456
  },
  {
    "key": "3_1_2_2_2_1_1",
    "scaleNumber": 710,
    "scale": [
      3,
      1,
      2,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 93,
    "all_scales_index": 839
  },
  {
    "key": "1_2_2_2_1_1_3",
    "scaleNumber": 711,
    "scale": [
      1,
      2,
      2,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 93,
    "all_scales_index": 382
  },
  {
    "key": "2_2_2_1_1_3_1",
    "scaleNumber": 712,
    "scale": [
      2,
      2,
      2,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 93,
    "all_scales_index": 703
  },
  {
    "key": "2_2_1_1_3_1_2",
    "scaleNumber": 713,
    "scale": [
      2,
      2,
      1,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 93,
    "all_scales_index": 674
  },
  {
    "key": "2_1_1_3_1_2_2",
    "scaleNumber": 714,
    "scale": [
      2,
      1,
      1,
      3,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 93,
    "all_scales_index": 577
  },
  {
    "key": "1_1_3_1_3_1_2",
    "scaleNumber": 715,
    "scale": [
      1,
      1,
      3,
      1,
      3,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 94,
    "all_scales_index": 251
  },
  {
    "key": "1_3_1_3_1_2_1",
    "scaleNumber": 716,
    "scale": [
      1,
      3,
      1,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 94,
    "all_scales_index": 462
  },
  {
    "key": "3_1_3_1_2_1_1",
    "scaleNumber": 717,
    "scale": [
      3,
      1,
      3,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 94,
    "all_scales_index": 850
  },
  {
    "key": "1_3_1_2_1_1_3",
    "scaleNumber": 718,
    "scale": [
      1,
      3,
      1,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 94,
    "all_scales_index": 450
  },
  {
    "key": "3_1_2_1_1_3_1",
    "scaleNumber": 719,
    "scale": [
      3,
      1,
      2,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 94,
    "all_scales_index": 828
  },
  {
    "key": "1_2_1_1_3_1_3",
    "scaleNumber": 720,
    "scale": [
      1,
      2,
      1,
      1,
      3,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 94,
    "all_scales_index": 314
  },
  {
    "key": "2_1_1_3_1_3_1",
    "scaleNumber": 721,
    "scale": [
      2,
      1,
      1,
      3,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 94,
    "all_scales_index": 578
  },
  {
    "key": "1_1_3_1_3_3",
    "scaleNumber": 722,
    "scale": [
      1,
      1,
      3,
      1,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 95,
    "all_scales_index": 253
  },
  {
    "key": "1_3_1_3_3_1",
    "scaleNumber": 723,
    "scale": [
      1,
      3,
      1,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 95,
    "all_scales_index": 466
  },
  {
    "key": "3_1_3_3_1_1",
    "scaleNumber": 724,
    "scale": [
      3,
      1,
      3,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 95,
    "all_scales_index": 857
  },
  {
    "key": "1_3_3_1_1_3",
    "scaleNumber": 725,
    "scale": [
      1,
      3,
      3,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 95,
    "all_scales_index": 494
  },
  {
    "key": "3_3_1_1_3_1",
    "scaleNumber": 726,
    "scale": [
      3,
      3,
      1,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 95,
    "all_scales_index": 909
  },
  {
    "key": "3_1_1_3_1_3",
    "scaleNumber": 727,
    "scale": [
      3,
      1,
      1,
      3,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 95,
    "all_scales_index": 818
  },
  {
    "key": "1_1_3_2_1_2_2",
    "scaleNumber": 728,
    "scale": [
      1,
      1,
      3,
      2,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 96,
    "all_scales_index": 259
  },
  {
    "key": "1_3_2_1_2_2_1",
    "scaleNumber": 729,
    "scale": [
      1,
      3,
      2,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 96,
    "all_scales_index": 476
  },
  {
    "key": "3_2_1_2_2_1_1",
    "scaleNumber": 730,
    "scale": [
      3,
      2,
      1,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 96,
    "all_scales_index": 876
  },
  {
    "key": "2_1_2_2_1_1_3",
    "scaleNumber": 731,
    "scale": [
      2,
      1,
      2,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 96,
    "all_scales_index": 612
  },
  {
    "key": "1_2_2_1_1_3_2",
    "scaleNumber": 732,
    "scale": [
      1,
      2,
      2,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 96,
    "all_scales_index": 367
  },
  {
    "key": "2_2_1_1_3_2_1",
    "scaleNumber": 733,
    "scale": [
      2,
      2,
      1,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 96,
    "all_scales_index": 675
  },
  {
    "key": "2_1_1_3_2_1_2",
    "scaleNumber": 734,
    "scale": [
      2,
      1,
      1,
      3,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 96,
    "all_scales_index": 580
  },
  {
    "key": "1_1_3_2_2_1_2",
    "scaleNumber": 735,
    "scale": [
      1,
      1,
      3,
      2,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 97,
    "all_scales_index": 262
  },
  {
    "key": "1_3_2_2_1_2_1",
    "scaleNumber": 736,
    "scale": [
      1,
      3,
      2,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 97,
    "all_scales_index": 482
  },
  {
    "key": "3_2_2_1_2_1_1",
    "scaleNumber": 737,
    "scale": [
      3,
      2,
      2,
      1,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 97,
    "all_scales_index": 887
  },
  {
    "key": "2_2_1_2_1_1_3",
    "scaleNumber": 738,
    "scale": [
      2,
      2,
      1,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 97,
    "all_scales_index": 680
  },
  {
    "key": "2_1_2_1_1_3_2",
    "scaleNumber": 739,
    "scale": [
      2,
      1,
      2,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 97,
    "all_scales_index": 597
  },
  {
    "key": "1_2_1_1_3_2_2",
    "scaleNumber": 740,
    "scale": [
      1,
      2,
      1,
      1,
      3,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 97,
    "all_scales_index": 316
  },
  {
    "key": "2_1_1_3_2_2_1",
    "scaleNumber": 741,
    "scale": [
      2,
      1,
      1,
      3,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 97,
    "all_scales_index": 581
  },
  {
    "key": "1_1_3_2_2_3",
    "scaleNumber": 742,
    "scale": [
      1,
      1,
      3,
      2,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 98,
    "all_scales_index": 264
  },
  {
    "key": "1_3_2_2_3_1",
    "scaleNumber": 743,
    "scale": [
      1,
      3,
      2,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 98,
    "all_scales_index": 486
  },
  {
    "key": "3_2_2_3_1_1",
    "scaleNumber": 744,
    "scale": [
      3,
      2,
      2,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 98,
    "all_scales_index": 894
  },
  {
    "key": "2_2_3_1_1_3",
    "scaleNumber": 745,
    "scale": [
      2,
      2,
      3,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 98,
    "all_scales_index": 724
  },
  {
    "key": "2_3_1_1_3_2",
    "scaleNumber": 746,
    "scale": [
      2,
      3,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 98,
    "all_scales_index": 746
  },
  {
    "key": "3_1_1_3_2_2",
    "scaleNumber": 747,
    "scale": [
      3,
      1,
      1,
      3,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 98,
    "all_scales_index": 820
  },
  {
    "key": "1_1_3_2_3_2",
    "scaleNumber": 748,
    "scale": [
      1,
      1,
      3,
      2,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 99,
    "all_scales_index": 266
  },
  {
    "key": "1_3_2_3_2_1",
    "scaleNumber": 749,
    "scale": [
      1,
      3,
      2,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 99,
    "all_scales_index": 489
  },
  {
    "key": "3_2_3_2_1_1",
    "scaleNumber": 750,
    "scale": [
      3,
      2,
      3,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 99,
    "all_scales_index": 900
  },
  {
    "key": "2_3_2_1_1_3",
    "scaleNumber": 751,
    "scale": [
      2,
      3,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 99,
    "all_scales_index": 761
  },
  {
    "key": "3_2_1_1_3_2",
    "scaleNumber": 752,
    "scale": [
      3,
      2,
      1,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 99,
    "all_scales_index": 871
  },
  {
    "key": "2_1_1_3_2_3",
    "scaleNumber": 753,
    "scale": [
      2,
      1,
      1,
      3,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 99,
    "all_scales_index": 582
  },
  {
    "key": "1_1_3_3_1_3",
    "scaleNumber": 754,
    "scale": [
      1,
      1,
      3,
      3,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 100,
    "all_scales_index": 270
  },
  {
    "key": "1_3_3_1_3_1",
    "scaleNumber": 755,
    "scale": [
      1,
      3,
      3,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 100,
    "all_scales_index": 497
  },
  {
    "key": "3_3_1_3_1_1",
    "scaleNumber": 756,
    "scale": [
      3,
      3,
      1,
      3,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 100,
    "all_scales_index": 914
  },
  {
    "key": "3_1_3_1_1_3",
    "scaleNumber": 757,
    "scale": [
      3,
      1,
      3,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 100,
    "all_scales_index": 849
  },
  {
    "key": "1_3_1_1_3_3",
    "scaleNumber": 758,
    "scale": [
      1,
      3,
      1,
      1,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 100,
    "all_scales_index": 446
  },
  {
    "key": "3_1_1_3_3_1",
    "scaleNumber": 759,
    "scale": [
      3,
      1,
      1,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 100,
    "all_scales_index": 821
  },
  {
    "key": "1_1_3_3_2_2",
    "scaleNumber": 760,
    "scale": [
      1,
      1,
      3,
      3,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 101,
    "all_scales_index": 272
  },
  {
    "key": "1_3_3_2_2_1",
    "scaleNumber": 761,
    "scale": [
      1,
      3,
      3,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 101,
    "all_scales_index": 500
  },
  {
    "key": "3_3_2_2_1_1",
    "scaleNumber": 762,
    "scale": [
      3,
      3,
      2,
      2,
      1,
      1
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 101,
    "all_scales_index": 920
  },
  {
    "key": "3_2_2_1_1_3",
    "scaleNumber": 763,
    "scale": [
      3,
      2,
      2,
      1,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 101,
    "all_scales_index": 886
  },
  {
    "key": "2_2_1_1_3_3",
    "scaleNumber": 764,
    "scale": [
      2,
      2,
      1,
      1,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 101,
    "all_scales_index": 676
  },
  {
    "key": "2_1_1_3_3_2",
    "scaleNumber": 765,
    "scale": [
      2,
      1,
      1,
      3,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 101,
    "all_scales_index": 584
  },
  {
    "key": "1_2_1_2_1_2_1_2",
    "scaleNumber": 766,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      2,
      1,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 102,
    "all_scales_index": 326
  },
  {
    "key": "2_1_2_1_2_1_2_1",
    "scaleNumber": 767,
    "scale": [
      2,
      1,
      2,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 102,
    "all_scales_index": 600
  },
  {
    "key": "1_2_1_2_1_2_3",
    "scaleNumber": 768,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 103,
    "all_scales_index": 328
  },
  {
    "key": "2_1_2_1_2_3_1",
    "scaleNumber": 769,
    "scale": [
      2,
      1,
      2,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 103,
    "all_scales_index": 604
  },
  {
    "key": "1_2_1_2_3_1_2",
    "scaleNumber": 770,
    "scale": [
      1,
      2,
      1,
      2,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 103,
    "all_scales_index": 339
  },
  {
    "key": "2_1_2_3_1_2_1",
    "scaleNumber": 771,
    "scale": [
      2,
      1,
      2,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 103,
    "all_scales_index": 624
  },
  {
    "key": "1_2_3_1_2_1_2",
    "scaleNumber": 772,
    "scale": [
      1,
      2,
      3,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 103,
    "all_scales_index": 407
  },
  {
    "key": "2_3_1_2_1_2_1",
    "scaleNumber": 773,
    "scale": [
      2,
      3,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 103,
    "all_scales_index": 749
  },
  {
    "key": "3_1_2_1_2_1_2",
    "scaleNumber": 774,
    "scale": [
      3,
      1,
      2,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 103,
    "all_scales_index": 830
  },
  {
    "key": "1_2_1_2_1_3_2",
    "scaleNumber": 775,
    "scale": [
      1,
      2,
      1,
      2,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 104,
    "all_scales_index": 330
  },
  {
    "key": "2_1_2_1_3_2_1",
    "scaleNumber": 776,
    "scale": [
      2,
      1,
      2,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 104,
    "all_scales_index": 607
  },
  {
    "key": "1_2_1_3_2_1_2",
    "scaleNumber": 777,
    "scale": [
      1,
      2,
      1,
      3,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 104,
    "all_scales_index": 350
  },
  {
    "key": "2_1_3_2_1_2_1",
    "scaleNumber": 778,
    "scale": [
      2,
      1,
      3,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 104,
    "all_scales_index": 644
  },
  {
    "key": "1_3_2_1_2_1_2",
    "scaleNumber": 779,
    "scale": [
      1,
      3,
      2,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 104,
    "all_scales_index": 475
  },
  {
    "key": "3_2_1_2_1_2_1",
    "scaleNumber": 780,
    "scale": [
      3,
      2,
      1,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 104,
    "all_scales_index": 874
  },
  {
    "key": "2_1_2_1_2_1_3",
    "scaleNumber": 781,
    "scale": [
      2,
      1,
      2,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 104,
    "all_scales_index": 601
  },
  {
    "key": "1_2_1_2_2_1_3",
    "scaleNumber": 782,
    "scale": [
      1,
      2,
      1,
      2,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 105,
    "all_scales_index": 334
  },
  {
    "key": "2_1_2_2_1_3_1",
    "scaleNumber": 783,
    "scale": [
      2,
      1,
      2,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 105,
    "all_scales_index": 615
  },
  {
    "key": "1_2_2_1_3_1_2",
    "scaleNumber": 784,
    "scale": [
      1,
      2,
      2,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 105,
    "all_scales_index": 376
  },
  {
    "key": "2_2_1_3_1_2_1",
    "scaleNumber": 785,
    "scale": [
      2,
      2,
      1,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 105,
    "all_scales_index": 692
  },
  {
    "key": "2_1_3_1_2_1_2",
    "scaleNumber": 786,
    "scale": [
      2,
      1,
      3,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 105,
    "all_scales_index": 637
  },
  {
    "key": "1_3_1_2_1_2_2",
    "scaleNumber": 787,
    "scale": [
      1,
      3,
      1,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 105,
    "all_scales_index": 452
  },
  {
    "key": "3_1_2_1_2_2_1",
    "scaleNumber": 788,
    "scale": [
      3,
      1,
      2,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 105,
    "all_scales_index": 831
  },
  {
    "key": "1_2_1_2_2_2_2",
    "scaleNumber": 789,
    "scale": [
      1,
      2,
      1,
      2,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 106,
    "all_scales_index": 336
  },
  {
    "key": "2_1_2_2_2_2_1",
    "scaleNumber": 790,
    "scale": [
      2,
      1,
      2,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 106,
    "all_scales_index": 618
  },
  {
    "key": "1_2_2_2_2_1_2",
    "scaleNumber": 791,
    "scale": [
      1,
      2,
      2,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 106,
    "all_scales_index": 387
  },
  {
    "key": "2_2_2_2_1_2_1",
    "scaleNumber": 792,
    "scale": [
      2,
      2,
      2,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 106,
    "all_scales_index": 712
  },
  {
    "key": "2_2_2_1_2_1_2",
    "scaleNumber": 793,
    "scale": [
      2,
      2,
      2,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 106,
    "all_scales_index": 705
  },
  {
    "key": "2_2_1_2_1_2_2",
    "scaleNumber": 794,
    "scale": [
      2,
      2,
      1,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 106,
    "all_scales_index": 682
  },
  {
    "key": "2_1_2_1_2_2_2",
    "scaleNumber": 795,
    "scale": [
      2,
      1,
      2,
      1,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 106,
    "all_scales_index": 603
  },
  {
    "key": "1_2_1_2_3_3",
    "scaleNumber": 796,
    "scale": [
      1,
      2,
      1,
      2,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 107,
    "all_scales_index": 341
  },
  {
    "key": "2_1_2_3_3_1",
    "scaleNumber": 797,
    "scale": [
      2,
      1,
      2,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 107,
    "all_scales_index": 628
  },
  {
    "key": "1_2_3_3_1_2",
    "scaleNumber": 798,
    "scale": [
      1,
      2,
      3,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 107,
    "all_scales_index": 420
  },
  {
    "key": "2_3_3_1_2_1",
    "scaleNumber": 799,
    "scale": [
      2,
      3,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 107,
    "all_scales_index": 773
  },
  {
    "key": "3_3_1_2_1_2",
    "scaleNumber": 800,
    "scale": [
      3,
      3,
      1,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 107,
    "all_scales_index": 911
  },
  {
    "key": "3_1_2_1_2_3",
    "scaleNumber": 801,
    "scale": [
      3,
      1,
      2,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 107,
    "all_scales_index": 832
  },
  {
    "key": "1_2_1_3_1_2_2",
    "scaleNumber": 802,
    "scale": [
      1,
      2,
      1,
      3,
      1,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 108,
    "all_scales_index": 347
  },
  {
    "key": "2_1_3_1_2_2_1",
    "scaleNumber": 803,
    "scale": [
      2,
      1,
      3,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 108,
    "all_scales_index": 638
  },
  {
    "key": "1_3_1_2_2_1_2",
    "scaleNumber": 804,
    "scale": [
      1,
      3,
      1,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 108,
    "all_scales_index": 455
  },
  {
    "key": "3_1_2_2_1_2_1",
    "scaleNumber": 805,
    "scale": [
      3,
      1,
      2,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 108,
    "all_scales_index": 837
  },
  {
    "key": "1_2_2_1_2_1_3",
    "scaleNumber": 806,
    "scale": [
      1,
      2,
      2,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 108,
    "all_scales_index": 371
  },
  {
    "key": "2_2_1_2_1_3_1",
    "scaleNumber": 807,
    "scale": [
      2,
      2,
      1,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 108,
    "all_scales_index": 683
  },
  {
    "key": "2_1_2_1_3_1_2",
    "scaleNumber": 808,
    "scale": [
      2,
      1,
      2,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 108,
    "all_scales_index": 606
  },
  {
    "key": "1_2_1_3_2_3",
    "scaleNumber": 809,
    "scale": [
      1,
      2,
      1,
      3,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 109,
    "all_scales_index": 352
  },
  {
    "key": "2_1_3_2_3_1",
    "scaleNumber": 810,
    "scale": [
      2,
      1,
      3,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 109,
    "all_scales_index": 648
  },
  {
    "key": "1_3_2_3_1_2",
    "scaleNumber": 811,
    "scale": [
      1,
      3,
      2,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 109,
    "all_scales_index": 488
  },
  {
    "key": "3_2_3_1_2_1",
    "scaleNumber": 812,
    "scale": [
      3,
      2,
      3,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 109,
    "all_scales_index": 898
  },
  {
    "key": "2_3_1_2_1_3",
    "scaleNumber": 813,
    "scale": [
      2,
      3,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 109,
    "all_scales_index": 750
  },
  {
    "key": "3_1_2_1_3_2",
    "scaleNumber": 814,
    "scale": [
      3,
      1,
      2,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 109,
    "all_scales_index": 834
  },
  {
    "key": "1_2_1_3_3_2",
    "scaleNumber": 815,
    "scale": [
      1,
      2,
      1,
      3,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 110,
    "all_scales_index": 354
  },
  {
    "key": "2_1_3_3_2_1",
    "scaleNumber": 816,
    "scale": [
      2,
      1,
      3,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 110,
    "all_scales_index": 651
  },
  {
    "key": "1_3_3_2_1_2",
    "scaleNumber": 817,
    "scale": [
      1,
      3,
      3,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 110,
    "all_scales_index": 499
  },
  {
    "key": "3_3_2_1_2_1",
    "scaleNumber": 818,
    "scale": [
      3,
      3,
      2,
      1,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 110,
    "all_scales_index": 918
  },
  {
    "key": "3_2_1_2_1_3",
    "scaleNumber": 819,
    "scale": [
      3,
      2,
      1,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 110,
    "all_scales_index": 875
  },
  {
    "key": "2_1_2_1_3_3",
    "scaleNumber": 820,
    "scale": [
      2,
      1,
      2,
      1,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 110,
    "all_scales_index": 608
  },
  {
    "key": "1_2_2_1_2_2_2",
    "scaleNumber": 821,
    "scale": [
      1,
      2,
      2,
      1,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 111,
    "all_scales_index": 373
  },
  {
    "key": "2_2_1_2_2_2_1",
    "scaleNumber": 822,
    "scale": [
      2,
      2,
      1,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 111,
    "all_scales_index": 686
  },
  {
    "key": "2_1_2_2_2_1_2",
    "scaleNumber": 823,
    "scale": [
      2,
      1,
      2,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 111,
    "all_scales_index": 617
  },
  {
    "key": "1_2_2_2_1_2_2",
    "scaleNumber": 824,
    "scale": [
      1,
      2,
      2,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 111,
    "all_scales_index": 384
  },
  {
    "key": "2_2_2_1_2_2_1",
    "scaleNumber": 825,
    "scale": [
      2,
      2,
      2,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 111,
    "all_scales_index": 706
  },
  {
    "key": "2_2_1_2_2_1_2",
    "scaleNumber": 826,
    "scale": [
      2,
      2,
      1,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 111,
    "all_scales_index": 685
  },
  {
    "key": "2_1_2_2_1_2_2",
    "scaleNumber": 827,
    "scale": [
      2,
      1,
      2,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 7,
    "superscale_index": 111,
    "all_scales_index": 614
  },
  {
    "key": "1_2_2_1_3_3",
    "scaleNumber": 828,
    "scale": [
      1,
      2,
      2,
      1,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 112,
    "all_scales_index": 378
  },
  {
    "key": "2_2_1_3_3_1",
    "scaleNumber": 829,
    "scale": [
      2,
      2,
      1,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 112,
    "all_scales_index": 696
  },
  {
    "key": "2_1_3_3_1_2",
    "scaleNumber": 830,
    "scale": [
      2,
      1,
      3,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 112,
    "all_scales_index": 650
  },
  {
    "key": "1_3_3_1_2_2",
    "scaleNumber": 831,
    "scale": [
      1,
      3,
      3,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 112,
    "all_scales_index": 496
  },
  {
    "key": "3_3_1_2_2_1",
    "scaleNumber": 832,
    "scale": [
      3,
      3,
      1,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 112,
    "all_scales_index": 912
  },
  {
    "key": "3_1_2_2_1_3",
    "scaleNumber": 833,
    "scale": [
      3,
      1,
      2,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 112,
    "all_scales_index": 838
  },
  {
    "key": "1_2_2_2_2_3",
    "scaleNumber": 834,
    "scale": [
      1,
      2,
      2,
      2,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 113,
    "all_scales_index": 389
  },
  {
    "key": "2_2_2_2_3_1",
    "scaleNumber": 835,
    "scale": [
      2,
      2,
      2,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 113,
    "all_scales_index": 716
  },
  {
    "key": "2_2_2_3_1_2",
    "scaleNumber": 836,
    "scale": [
      2,
      2,
      2,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 113,
    "all_scales_index": 718
  },
  {
    "key": "2_2_3_1_2_2",
    "scaleNumber": 837,
    "scale": [
      2,
      2,
      3,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 113,
    "all_scales_index": 726
  },
  {
    "key": "2_3_1_2_2_2",
    "scaleNumber": 838,
    "scale": [
      2,
      3,
      1,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 113,
    "all_scales_index": 752
  },
  {
    "key": "3_1_2_2_2_2",
    "scaleNumber": 839,
    "scale": [
      3,
      1,
      2,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 113,
    "all_scales_index": 840
  },
  {
    "key": "1_2_2_2_3_2",
    "scaleNumber": 840,
    "scale": [
      1,
      2,
      2,
      2,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 114,
    "all_scales_index": 391
  },
  {
    "key": "2_2_2_3_2_1",
    "scaleNumber": 841,
    "scale": [
      2,
      2,
      2,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 114,
    "all_scales_index": 719
  },
  {
    "key": "2_2_3_2_1_2",
    "scaleNumber": 842,
    "scale": [
      2,
      2,
      3,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 114,
    "all_scales_index": 729
  },
  {
    "key": "2_3_2_1_2_2",
    "scaleNumber": 843,
    "scale": [
      2,
      3,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 114,
    "all_scales_index": 763
  },
  {
    "key": "3_2_1_2_2_2",
    "scaleNumber": 844,
    "scale": [
      3,
      2,
      1,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 114,
    "all_scales_index": 877
  },
  {
    "key": "2_1_2_2_2_3",
    "scaleNumber": 845,
    "scale": [
      2,
      1,
      2,
      2,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 114,
    "all_scales_index": 619
  },
  {
    "key": "1_2_2_3_1_3",
    "scaleNumber": 846,
    "scale": [
      1,
      2,
      2,
      3,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 115,
    "all_scales_index": 395
  },
  {
    "key": "2_2_3_1_3_1",
    "scaleNumber": 847,
    "scale": [
      2,
      2,
      3,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 115,
    "all_scales_index": 727
  },
  {
    "key": "2_3_1_3_1_2",
    "scaleNumber": 848,
    "scale": [
      2,
      3,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 115,
    "all_scales_index": 755
  },
  {
    "key": "3_1_3_1_2_2",
    "scaleNumber": 849,
    "scale": [
      3,
      1,
      3,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 115,
    "all_scales_index": 851
  },
  {
    "key": "1_3_1_2_2_3",
    "scaleNumber": 850,
    "scale": [
      1,
      3,
      1,
      2,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 115,
    "all_scales_index": 457
  },
  {
    "key": "3_1_2_2_3_1",
    "scaleNumber": 851,
    "scale": [
      3,
      1,
      2,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 115,
    "all_scales_index": 841
  },
  {
    "key": "1_2_2_3_2_2",
    "scaleNumber": 852,
    "scale": [
      1,
      2,
      2,
      3,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 116,
    "all_scales_index": 397
  },
  {
    "key": "2_2_3_2_2_1",
    "scaleNumber": 853,
    "scale": [
      2,
      2,
      3,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 116,
    "all_scales_index": 730
  },
  {
    "key": "2_3_2_2_1_2",
    "scaleNumber": 854,
    "scale": [
      2,
      3,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 116,
    "all_scales_index": 766
  },
  {
    "key": "3_2_2_1_2_2",
    "scaleNumber": 855,
    "scale": [
      3,
      2,
      2,
      1,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 116,
    "all_scales_index": 888
  },
  {
    "key": "2_2_1_2_2_3",
    "scaleNumber": 856,
    "scale": [
      2,
      2,
      1,
      2,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 116,
    "all_scales_index": 687
  },
  {
    "key": "2_1_2_2_3_2",
    "scaleNumber": 857,
    "scale": [
      2,
      1,
      2,
      2,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 116,
    "all_scales_index": 621
  },
  {
    "key": "1_2_3_1_2_3",
    "scaleNumber": 858,
    "scale": [
      1,
      2,
      3,
      1,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 117,
    "all_scales_index": 409
  },
  {
    "key": "2_3_1_2_3_1",
    "scaleNumber": 859,
    "scale": [
      2,
      3,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 117,
    "all_scales_index": 753
  },
  {
    "key": "3_1_2_3_1_2",
    "scaleNumber": 860,
    "scale": [
      3,
      1,
      2,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 117,
    "all_scales_index": 843
  },
  {
    "key": "1_2_3_1_3_2",
    "scaleNumber": 861,
    "scale": [
      1,
      2,
      3,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 118,
    "all_scales_index": 411
  },
  {
    "key": "2_3_1_3_2_1",
    "scaleNumber": 862,
    "scale": [
      2,
      3,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 118,
    "all_scales_index": 756
  },
  {
    "key": "3_1_3_2_1_2",
    "scaleNumber": 863,
    "scale": [
      3,
      1,
      3,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 118,
    "all_scales_index": 854
  },
  {
    "key": "1_3_2_1_2_3",
    "scaleNumber": 864,
    "scale": [
      1,
      3,
      2,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 118,
    "all_scales_index": 477
  },
  {
    "key": "3_2_1_2_3_1",
    "scaleNumber": 865,
    "scale": [
      3,
      2,
      1,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 118,
    "all_scales_index": 878
  },
  {
    "key": "2_1_2_3_1_3",
    "scaleNumber": 866,
    "scale": [
      2,
      1,
      2,
      3,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 118,
    "all_scales_index": 625
  },
  {
    "key": "1_2_3_2_1_3",
    "scaleNumber": 867,
    "scale": [
      1,
      2,
      3,
      2,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 119,
    "all_scales_index": 415
  },
  {
    "key": "2_3_2_1_3_1",
    "scaleNumber": 868,
    "scale": [
      2,
      3,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 119,
    "all_scales_index": 764
  },
  {
    "key": "3_2_1_3_1_2",
    "scaleNumber": 869,
    "scale": [
      3,
      2,
      1,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 119,
    "all_scales_index": 880
  },
  {
    "key": "2_1_3_1_2_3",
    "scaleNumber": 870,
    "scale": [
      2,
      1,
      3,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 119,
    "all_scales_index": 639
  },
  {
    "key": "1_3_1_2_3_2",
    "scaleNumber": 871,
    "scale": [
      1,
      3,
      1,
      2,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 119,
    "all_scales_index": 459
  },
  {
    "key": "3_1_2_3_2_1",
    "scaleNumber": 872,
    "scale": [
      3,
      1,
      2,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 119,
    "all_scales_index": 844
  },
  {
    "key": "1_2_3_2_2_2",
    "scaleNumber": 873,
    "scale": [
      1,
      2,
      3,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 120,
    "all_scales_index": 417
  },
  {
    "key": "2_3_2_2_2_1",
    "scaleNumber": 874,
    "scale": [
      2,
      3,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 120,
    "all_scales_index": 767
  },
  {
    "key": "3_2_2_2_1_2",
    "scaleNumber": 875,
    "scale": [
      3,
      2,
      2,
      2,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 120,
    "all_scales_index": 891
  },
  {
    "key": "2_2_2_1_2_3",
    "scaleNumber": 876,
    "scale": [
      2,
      2,
      2,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 120,
    "all_scales_index": 707
  },
  {
    "key": "2_2_1_2_3_2",
    "scaleNumber": 877,
    "scale": [
      2,
      2,
      1,
      2,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 120,
    "all_scales_index": 689
  },
  {
    "key": "2_1_2_3_2_2",
    "scaleNumber": 878,
    "scale": [
      2,
      1,
      2,
      3,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 120,
    "all_scales_index": 627
  },
  {
    "key": "1_2_3_3_3",
    "scaleNumber": 879,
    "scale": [
      1,
      2,
      3,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 121,
    "all_scales_index": 422
  },
  {
    "key": "2_3_3_3_1",
    "scaleNumber": 880,
    "scale": [
      2,
      3,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 121,
    "all_scales_index": 777
  },
  {
    "key": "3_3_3_1_2",
    "scaleNumber": 881,
    "scale": [
      3,
      3,
      3,
      1,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 121,
    "all_scales_index": 924
  },
  {
    "key": "3_3_1_2_3",
    "scaleNumber": 882,
    "scale": [
      3,
      3,
      1,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 121,
    "all_scales_index": 913
  },
  {
    "key": "3_1_2_3_3",
    "scaleNumber": 883,
    "scale": [
      3,
      1,
      2,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 121,
    "all_scales_index": 845
  },
  {
    "key": "1_3_1_3_1_3",
    "scaleNumber": 884,
    "scale": [
      1,
      3,
      1,
      3,
      1,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 122,
    "all_scales_index": 463
  },
  {
    "key": "3_1_3_1_3_1",
    "scaleNumber": 885,
    "scale": [
      3,
      1,
      3,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 122,
    "all_scales_index": 852
  },
  {
    "key": "1_3_1_3_2_2",
    "scaleNumber": 886,
    "scale": [
      1,
      3,
      1,
      3,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 123,
    "all_scales_index": 465
  },
  {
    "key": "3_1_3_2_2_1",
    "scaleNumber": 887,
    "scale": [
      3,
      1,
      3,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 123,
    "all_scales_index": 855
  },
  {
    "key": "1_3_2_2_1_3",
    "scaleNumber": 888,
    "scale": [
      1,
      3,
      2,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 123,
    "all_scales_index": 483
  },
  {
    "key": "3_2_2_1_3_1",
    "scaleNumber": 889,
    "scale": [
      3,
      2,
      2,
      1,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 123,
    "all_scales_index": 889
  },
  {
    "key": "2_2_1_3_1_3",
    "scaleNumber": 890,
    "scale": [
      2,
      2,
      1,
      3,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 123,
    "all_scales_index": 693
  },
  {
    "key": "2_1_3_1_3_2",
    "scaleNumber": 891,
    "scale": [
      2,
      1,
      3,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 123,
    "all_scales_index": 641
  },
  {
    "key": "1_3_2_1_3_2",
    "scaleNumber": 892,
    "scale": [
      1,
      3,
      2,
      1,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 124,
    "all_scales_index": 479
  },
  {
    "key": "3_2_1_3_2_1",
    "scaleNumber": 893,
    "scale": [
      3,
      2,
      1,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 124,
    "all_scales_index": 881
  },
  {
    "key": "2_1_3_2_1_3",
    "scaleNumber": 894,
    "scale": [
      2,
      1,
      3,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 124,
    "all_scales_index": 645
  },
  {
    "key": "1_3_2_2_2_2",
    "scaleNumber": 895,
    "scale": [
      1,
      3,
      2,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 125,
    "all_scales_index": 485
  },
  {
    "key": "3_2_2_2_2_1",
    "scaleNumber": 896,
    "scale": [
      3,
      2,
      2,
      2,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 125,
    "all_scales_index": 892
  },
  {
    "key": "2_2_2_2_1_3",
    "scaleNumber": 897,
    "scale": [
      2,
      2,
      2,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 125,
    "all_scales_index": 713
  },
  {
    "key": "2_2_2_1_3_2",
    "scaleNumber": 898,
    "scale": [
      2,
      2,
      2,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 125,
    "all_scales_index": 709
  },
  {
    "key": "2_2_1_3_2_2",
    "scaleNumber": 899,
    "scale": [
      2,
      2,
      1,
      3,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 125,
    "all_scales_index": 695
  },
  {
    "key": "2_1_3_2_2_2",
    "scaleNumber": 900,
    "scale": [
      2,
      1,
      3,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 6,
    "superscale_index": 125,
    "all_scales_index": 647
  },
  {
    "key": "1_3_2_3_3",
    "scaleNumber": 901,
    "scale": [
      1,
      3,
      2,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 126,
    "all_scales_index": 490
  },
  {
    "key": "3_2_3_3_1",
    "scaleNumber": 902,
    "scale": [
      3,
      2,
      3,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 126,
    "all_scales_index": 902
  },
  {
    "key": "2_3_3_1_3",
    "scaleNumber": 903,
    "scale": [
      2,
      3,
      3,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 126,
    "all_scales_index": 774
  },
  {
    "key": "3_3_1_3_2",
    "scaleNumber": 904,
    "scale": [
      3,
      3,
      1,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 126,
    "all_scales_index": 915
  },
  {
    "key": "3_1_3_2_3",
    "scaleNumber": 905,
    "scale": [
      3,
      1,
      3,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 126,
    "all_scales_index": 856
  },
  {
    "key": "1_3_3_2_3",
    "scaleNumber": 906,
    "scale": [
      1,
      3,
      3,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 127,
    "all_scales_index": 501
  },
  {
    "key": "3_3_2_3_1",
    "scaleNumber": 907,
    "scale": [
      3,
      3,
      2,
      3,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 127,
    "all_scales_index": 922
  },
  {
    "key": "3_2_3_1_3",
    "scaleNumber": 908,
    "scale": [
      3,
      2,
      3,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 127,
    "all_scales_index": 899
  },
  {
    "key": "2_3_1_3_3",
    "scaleNumber": 909,
    "scale": [
      2,
      3,
      1,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 127,
    "all_scales_index": 757
  },
  {
    "key": "3_1_3_3_2",
    "scaleNumber": 910,
    "scale": [
      3,
      1,
      3,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 127,
    "all_scales_index": 858
  },
  {
    "key": "1_3_3_3_2",
    "scaleNumber": 911,
    "scale": [
      1,
      3,
      3,
      3,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 128,
    "all_scales_index": 503
  },
  {
    "key": "3_3_3_2_1",
    "scaleNumber": 912,
    "scale": [
      3,
      3,
      3,
      2,
      1
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 128,
    "all_scales_index": 925
  },
  {
    "key": "3_3_2_1_3",
    "scaleNumber": 913,
    "scale": [
      3,
      3,
      2,
      1,
      3
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 128,
    "all_scales_index": 919
  },
  {
    "key": "3_2_1_3_3",
    "scaleNumber": 914,
    "scale": [
      3,
      2,
      1,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 128,
    "all_scales_index": 882
  },
  {
    "key": "2_1_3_3_3",
    "scaleNumber": 915,
    "scale": [
      2,
      1,
      3,
      3,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 128,
    "all_scales_index": 652
  },
  {
    "key": "2_2_2_2_2_2",
    "scaleNumber": 916,
    "scale": [
      2,
      2,
      2,
      2,
      2,
      2
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 129,
    "all_scales_index": 715
  },
  {
    "key": "2_2_2_3_3",
    "scaleNumber": 917,
    "scale": [
      2,
      2,
      2,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 130,
    "all_scales_index": 720
  },
  {
    "key": "2_2_3_3_2",
    "scaleNumber": 918,
    "scale": [
      2,
      2,
      3,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 130,
    "all_scales_index": 733
  },
  {
    "key": "2_3_3_2_2",
    "scaleNumber": 919,
    "scale": [
      2,
      3,
      3,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 130,
    "all_scales_index": 776
  },
  {
    "key": "3_3_2_2_2",
    "scaleNumber": 920,
    "scale": [
      3,
      3,
      2,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 130,
    "all_scales_index": 921
  },
  {
    "key": "3_2_2_2_3",
    "scaleNumber": 921,
    "scale": [
      3,
      2,
      2,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 130,
    "all_scales_index": 893
  },
  {
    "key": "2_2_3_2_3",
    "scaleNumber": 922,
    "scale": [
      2,
      2,
      3,
      2,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 131,
    "all_scales_index": 731
  },
  {
    "key": "2_3_2_3_2",
    "scaleNumber": 923,
    "scale": [
      2,
      3,
      2,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 2,
    "superscale_index": 131,
    "all_scales_index": 770
  },
  {
    "key": "3_2_3_2_2",
    "scaleNumber": 924,
    "scale": [
      3,
      2,
      3,
      2,
      2
    ],
    "is_superscale": false,
    "mode": 3,
    "superscale_index": 131,
    "all_scales_index": 901
  },
  {
    "key": "2_3_2_2_3",
    "scaleNumber": 925,
    "scale": [
      2,
      3,
      2,
      2,
      3
    ],
    "is_superscale": false,
    "mode": 4,
    "superscale_index": 131,
    "all_scales_index": 768
  },
  {
    "key": "3_2_2_3_2",
    "scaleNumber": 926,
    "scale": [
      3,
      2,
      2,
      3,
      2
    ],
    "is_superscale": false,
    "mode": 5,
    "superscale_index": 131,
    "all_scales_index": 895
  },
  {
    "key": "3_3_3_3",
    "scaleNumber": 927,
    "scale": [
      3,
      3,
      3,
      3
    ],
    "is_superscale": true,
    "mode": 1,
    "superscale_index": 132,
    "all_scales_index": 926
  }
]